(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(18115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cC": function() { return /* reexport */ Trans/* Trans */.c; },
  "$G": function() { return /* reexport */ useTranslation/* useTranslation */.$; }
});

// UNUSED EXPORTS: default

// NAMESPACE OBJECT: ./src/locales/de/index.ts
var de_namespaceObject = {};
__webpack_require__.r(de_namespaceObject);
__webpack_require__.d(de_namespaceObject, {
  "admin": function() { return admin_namespaceObject; },
  "auth": function() { return auth_namespaceObject; },
  "certificate": function() { return certificate_namespaceObject; },
  "common": function() { return common_namespaceObject; },
  "errors": function() { return errors_namespaceObject; },
  "layout": function() { return layout_namespaceObject; },
  "management": function() { return management_namespaceObject; },
  "page_homepage": function() { return page_homepage_namespaceObject; },
  "readingHabits": function() { return readingHabits_namespaceObject; },
  "validation": function() { return validation_namespaceObject; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatRelative/index.js + 21 modules
var formatRelative = __webpack_require__(88401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 15 modules
var i18next = __webpack_require__(60923);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 3 modules
var context = __webpack_require__(65091);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 4 modules
var Trans = __webpack_require__(99955);
;// CONCATENATED MODULE: ./src/locales/de/admin.json
var admin_namespaceObject = JSON.parse('{"account":{"verified":"Account bestätigt","unverified":"Account unbestätigt","notConnected":"Kein Account verknüpft","readingHabit":"Leseumfrage ja","noReadingHabit":"Leseumfrage nein"},"nativeSpeaker":{"label":"Muttersprache","labelWithValue":"$t(admin:nativeSpeaker.label): $t(admin:nativeSpeaker.values.{{value}})","values":{"NO":"nein","YES":"ja"}},"readsInFreeTime":{"label":"Liest in Freizeit","labelWithValue":"$t(admin:readsInFreeTime.label): $t(admin:readsInFreeTime.values.{{value}})","values":{"NO":"nein","YES":"ja"}},"readingSkill":{"label":"Lesefähigkeit","labelWithValue":"$t(admin:readingSkill.label): $t(admin:readingSkill.values.{{value}})","values":{"LOW":"gering","GOOD":"gut","FLUENT":"flüssig"}},"booksReadYearly":{"label":"Bücher pro Jahr","labelWithValue":"$t(admin:booksReadYearly.label): $t(admin:booksReadYearly.values.{{value}})","values":{"ZERO_TO_FIVE":"0-5","FIVE_TO_TEN":"5-10","TEN_TO_FIFTEEN":"10-15","MORE_THAN_FIFTEEN":"> 15"}},"readingRelatives":{"label":"Lesende Verwandte","labelWithValue":"$t(admin:booksReadYearly.label): {{values}}","values":{"GRANDFATHER":"Oma","GRANDMOTHER":"Opa","SIBLING":"Geschwister","MOTHER":"Mutter","FATHER":"Vater","NONE":"Keine"}},"graphs":{"legend":{"readPages":"Gelesene Seiten"}},"studentDetails":{"changeSchoolAndClass":{"school":"Schule","schoolClass":"Klasse","warning":"Das bisherige Lese-Protokoll wird der neuen Klasse und Schule zugeordnet!","submit":"Zuordnung ändern","notification":{"success":{"title":"Klassenzuordnung geändert","message":"Die Klassenzuordnung wurde geändert und das Lese-Protokoll neu zugeordnet"}}},"readAchievements":{"delete":{"submit":"Löschen","confirm":{"title":"Lese-Eintrag entfernen?","message":"Wenn Sie diesen Lese-Eintrag löschen, werden dadurch erreichte Level ebenfalls gelöscht."},"notification":{"success":{"title":"Lese-Eintrag entfernt","message":"Der Lese-Eintrag wurde erfolgreich gelöscht."}}}}},"studentsList":{"student":{"delete":{"submit":"Löschen","confirm":{"title":"Schüler:in entfernen?","message":"Möchten Sie <strong>{{student}}</strong> wirklich löschen? <br/> <br/> Wenn Sie diese Schüler:in löschen, werden alle Lese-Erfolge mit gelöscht."},"notification":{"success":{"title":"Schüler:in entfernt","message":"Der Datensatz wurde erfolgreich gelöscht."}}}}},"usersList":{"user":{"delete":{"submit":"Löschen","confirm":{"title":"User entfernen?","message":"Wenn Sie diesen User löschen, hat dieser keinen Zugriff mehr."},"notification":{"success":{"title":"User entfernt","message":"Der Datensatz wurde erfolgreich gelöscht."}}},"invite":{"buttonReInvite":"Erneut einladen","notification":{"success":{"title":"User eingeladen","message":"Der User wurde erfolgreich eingeladen."}}}}},"role":{"ROLE_USER":"User","ROLE_SUPERADMIN":"Superadmin","ROLE_ADMIN":"Admin","ROLE_ADMIN_ACCESS":"Admin-Zugang","ROLE_STUDENT":"Schüler","ROLE_TEACHER":"Lehrer"}}');
;// CONCATENATED MODULE: ./src/locales/de/auth.json
var auth_namespaceObject = JSON.parse('{"login":{"headline":"Hallo 👋","subheadline":"Du hast noch keinen Account? <registerLink>Account erstellen</registerLink>.","forgotPassword":"Passwort vergessen?","sessionExpired":"Deine Sitzung ist abgelaufen. Bitte melde dich neu an.","form":{"submit":"Anmelden","fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"},"password":{"label":"Passwort","placeholder":"Dein Passwort"}}}},"register":{"headline":"Neu hier?","subheadline":"Dann erstelle dir einen Account. <br /> Du hast schon Einen? Dann <loginLink>melde dich an</loginLink>.","infoForEmail":"Vermeide Tippfehler bei deiner E-Mail-Adresse. Denn wenn du sie falsch eingibst, kannst du dich bei Next Level nicht anmelden.","form":{"submit":"Account erstellen","sections":{"loginData":"Daten zum Anmelden","studentData":"Informationen über Dich"},"fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"},"password":{"label":"Passwort","placeholder":"Dein gewünschtes Passwort"},"passwordRepeat":{"label":"Passwort wiederholen","placeholder":"Passwort wiederholen"},"givenName":{"label":"Vorname","placeholder":"Vorname"},"familyName":{"label":"Nachname","placeholder":"Nachname"},"school":{"label":"Schule","placeholder":"Wähle deine Schule"},"schoolClass":{"label":"Klasse","placeholder":"Wähle deine Klasse","groupName":"{{grade}}. Klasse"},"nameOfLegalGuardian":{"label":"Vor- und Zuname des Erziehungsberechtigten","placeholder":""},"signedUpByLegalGuardian":{"label":"Ich als Erziehungsberechtigte(r) habe die Anmeldung für das Projekt Next Level der Stadtbibliothek Gütersloh gemeinsam mit meinem Kind durchgeführt.","placeholder":""}}}},"recover":{"pageTitle":"Passwort vergessen","title":"Passwort vergessen?","intro":"<firstParagraph>Es kann jedem mal passieren das Passwort zu vergessen. Das ist gar nicht schlimm. Wenn du die E-Mail-Adresse einträgst mit der du dich registriert hast, dann schicken wir dir eine E-Mail zu.</firstParagraph><secondParagraph>In der E-Mail ist dann ein Link den du anklicken musst. Und dann gelangst du zu einer Seite, wo du ein neues Passwort speichern kannst.</secondParagraph>","form":{"submit":"Absenden","fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"}}}},"invite":{"pageTitle":"User Einladung","title":"Einladung zum Admin Bereich","intro":"<firstParagraph>Sie wurden zum Admin-Bereich von Next Level eingeladen. Bitte wählen Sie ihr persönliches Passwort mit dem Sie sich danach im Admin-Bereich anmelden können.</firstParagraph>"},"recoverCheckEmail":{"pageTitle":"E-Mail überprüfen","title":"Überprüfe deine E-Mails","alert":{"title":"Anfrage versendet","text":"Wenn ein Konto existiert, das mit Deiner E-Mail-Adresse übereinstimmt, wurde soeben eine E-Mail mit einem Link verschickt, mit dem du dein Passwort zurücksetzen kannst. Der Link verliert in 1 Stunde seine Gültigkeit."},"spamHint":"Wenn du keine E-Mail erhältst, dann schaue bitte in deinem Spam-Ordner nach oder <recoverLink>versuche es noch einmal</recoverLink>."}}');
;// CONCATENATED MODULE: ./src/locales/de/certificate.json
var certificate_namespaceObject = JSON.parse('{"title":"Urkunde","salutation":"{{name}},","intro":"du hast bei NEXT LEVEL bereits {{pages, number}} Seiten gelesen und darfst jetzt stolz den Titel {{levelTitle}} tragen.","intro_1":"du hast bei NEXT LEVEL bereits 1 Buch gelesen und darfst jetzt stolz den Titel {{levelTitle}} tragen.","outro_3":"Entdecker:innen wie Christoph Kolumbus oder Jeanne Baré sind bei ihren Reisen in Regionen der Welt vorgedrungen, die zuvor weitgehend unbekannt waren. Sie haben mutig Neues gewagt und kehrten mit überraschenden Erkenntnissen und reich an Erfahrung heim. \\n\\nBist du auch mutig und neugierig? Dann wähle doch dein nächstes Buch mal aus einer anderen Rubrik aus. Bestimmt gibt es in der Mediothek noch viel Unbekanntes für dich zu entdecken!","outro_6":"Ein Meister ist eine Person, die durch außergewöhnliche Leistungen aufgefallen ist bzw. die sich zu einem bestimmten Fachgebiet besonders viel Wissen angeeignet hat. \\n\\nSo ist es auch bei dir: du hast {{pages, number}} Seiten gelesen, eine außergewöhnliche Lese-Leistung! Dabei hast du dich mit den Geschichten und Gedanken anderer Menschen vertraut gemacht und sicher Bücher entdeckt, die dir besonders gut gefallen haben. Gib deine Buchtipps an andere weiter, denn Meister:innen teilen ihr Wissen gerne!","outro_8":"Das Wort Guru kommt aus einer alt-indischen Sprache und bedeutet Lehrer bzw. Vorbild. Ein Guru teilt sein Wissen und hat viele Anhänger, die seinem Beispiel folgen. \\n\\nBestimmt motiviert es andere Kinder zu sehen, wieviel Spaß dir das Lesen macht. Hast du nicht Lust, einmal selbst eine Geschichte zu schreiben? \\n\\nProbier es doch mal aus!"}');
;// CONCATENATED MODULE: ./src/locales/de/common.json
var common_namespaceObject = JSON.parse('{"yes":"Ja","no":"Nein","cancel":"Abbrechen","delete":"Löschen","pages_other":"{{count, number}} Seiten","pages_one":"{{count, number}} Seite","books_other":"{{count, number}} Bücher","books_one":"{{count, number}} Buch","date":"{{date, datetime}}","dateRelative":"{{date, datetorelative}}","number":"{{number, number}}","readBooks":"Du hast $t(books) gelesen","readPagesOverall":"Du hast schon <strong>$t(pages)</strong> gelesen. <br> dein Bücherstapel ist <strong>{{count, stacksize, unit}}</strong> hoch.","readPagesOverall_zero":"Du hast im Projekt noch kein Buch gelesen. <br> Sobald du dein erstes Buch erfasst hast, siehst du hier wie hoch dein Bücherstapel ist.","pagesToNextLevel":"Noch <strong>$t(pages)</strong> zum nächsten Level!","readFirstBookForFirstLevel":"Lies jetzt dein <strong>erstes Buch</strong> um das nächste Level zu erreichen.","readFirstBookForFirstLevelWithCertificate":"$t(readFirstBookForFirstLevel) und <strong>eine Urkunde</strong> zu erhalten.","scanSuccess":{"addedPages":"Du hast damit <strong>$t(pages) ({{count, stacksize, unit}})</strong> zu deinem Bücherstapel hinzugefügt.","addedPages_causedLevel":"Du hast damit <strong>$t(pages) ({{count, stacksize, unit}})</strong> zu deinem Bücherstapel hinzugefügt und darfst dich jetzt <strong>{{causedLevel.name}}</strong> nennen.","addedPages_zero":"Leider haben wir keine Information wie viele Seiten dieses Buch beinhaltet. Bitte wende dich an deine Schulmediothek."},"student":{"readPages":"{{name}} hat schon $t(pages) gelesen. Der Bücherstapel von {{name}} ist {{count, stacksize, unit}} hoch.","readPages_zero":"{{name}} hat im Projekt noch kein Buch gelesen. Sobald {{name}} ein Buch erfasst hat, wird hier die Höhe des Bücherstapels angezeigt."},"class":{"readPages":"Deine {{name}} hat schon $t(pages) gelesen. Der Bücherstapel deiner {{name}} ist {{count, stacksize, unit}} hoch."},"school":{"readPages":"$t(class.readPages)"},"authError":{"INVALID_CREDENTIALS":"E-Mail-Adresse oder Passwort falsch","NOT_ALLOWED":"Keine Zugangsberechtigung"}}');
;// CONCATENATED MODULE: ./src/locales/de/errors.json
var errors_namespaceObject = JSON.parse('{"default":"Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt noch einmal.","required":"Dieses Feld ist ein Pflichtfeld","survey":{"required":"Bitte wähle eine Antwort aus."},"runtime":{"1658943826":"Dieses Buch wurde bereits von dir für NEXT LEVEL gewertet.","1658945694":"Dieses Buch kannst du nicht für NEXT LEVEL werten, weil du es nicht entliehen hast.","1658945928":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in.","1661857824":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in.","1662733460":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in."},"precondition-failed":{"media not lent":"Dieses Buch kannst du nicht für NEXT LEVEL werten, weil du es nicht entliehen hast.","media-group invalid":"Dieser Titel kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an deine Schulbibliothekarin.","media-classification not allowed":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an deine Schulbibliothekarin.","media already scanned":"Das Buch scheint nicht auf deine Konto verbucht zu sein. Bitte wende dich an deine Schulbibliothekarin.","media already in library":"Dieses Buch wurde bereits von dir für NEXT LEVEL gewertet."},"not-found":{"9633425e-8d52-48a0-bf1f-de4eb9124b06":"Dieses Buch kannst du nicht für NEXT LEVEL werten, da es nicht aus einer teilnehmenden Bibliothek kommt."}}');
;// CONCATENATED MODULE: ./src/locales/de/layout.json
var layout_namespaceObject = JSON.parse('{"header":{"links":{"login":"Anmelden","register":"Registrieren"}},"footer":{"links":{"imprint":"Impressum","privacyProtection":"Datenschutz"},"supportedBy":"NEXT LEVEL wird unterstützt durch die","realizedBy":"und umgesetzt von"}}');
;// CONCATENATED MODULE: ./src/locales/de/management.json
var management_namespaceObject = JSON.parse('{"readAchievementProbe":{"check":{"not found":"Mediennummer in der Datenbank vorhanden","media not lent":"Verfügbarkeit","media-group invalid":"Mediengruppe","media-classification not allowed":"Klassifikation","media already in library":"Vom Schüler noch nicht erfasst","media already scanned":"Nicht innerhalb des Zeitraumes von einem anderen Schüler erfasst"},"alreadyExists":{"media already in library":"Am {{ offendingReadAchievement.createTime, datetime }} Uhr vom Schüler erfasst","media already scanned":"Am {{ offendingReadAchievement.createTime, datetime }} Uhr von einem anderen Schüler erfasst"},"value":{"media already in library":"Vom Schüler noch nicht erfasst","media already scanned":"Nicht von einem anderen Schüler erfasst"}},"levelNotification":{"certificate":{"actionText":"Urkunde ausstellen","highlightColor":"accent-1"},"letter-teacher":{"actionText":"Brief von der Klassenleitung","highlightColor":"neutral-3"},"school-report":{"actionText":"positive Bewertung auf dem Zeugnis","highlightColor":"accent-3"},"letter-headmaster":{"actionText":"Brief von der Schulleitung","highlightColor":"accent-4"}}}');
;// CONCATENATED MODULE: ./src/locales/de/page_homepage.json
var page_homepage_namespaceObject = JSON.parse('{"hero":{"title":"NEXT LEVEL","subtitle":"die App der Schulmediotheken Gütersloh","steps":{"1":"<strong>Lies ein Buch</strong> aus Deiner Schulmediothek.","2":"<strong>Fertig gelesen?</strong> <br> Dann scanne die Mediennummer des Buches.","3":"Und steige damit ins <strong>nächste Level</strong> auf!"},"cta":{"login":"Einloggen","register":"Neu registrieren"}},"intro":{"text":"Die App <strong>NEXT LEVEL</strong> zählt alle gelesenen Seiten zusammen und zeigt Euch, wie viel ihr insgesamt gelesen habt. Nehmt als ganze Klasse teil und lasst euren Bücherstapel schnell in die Höhe wachsen!"},"stats":{"stackHeight":{"unit":"<number>{{height}}</number> Meter","description":"hoher Bücherstapel","currentYear":"davon im aktuellen Schuljahr"},"readPages":{"description":"gelesene Seiten","currentYear":"davon im aktuellen Schuljahr"},"schools":{"unit_one":"{{count, number}} Schule","unit_other":"{{count, number}} Schulen","description":"nehmen am <br> Projekt teil"},"students":{"unit":"{{count, number}} Schüler:innen","description":"machen schon mit"}},"nextStudent":{"headline":"Bist du als nächstes dabei?","cta":"Jetzt registrieren"},"currentBooks":{"headline":"Was aktuell <br> gelesen wird"}}');
;// CONCATENATED MODULE: ./src/locales/de/readingHabits.json
var readingHabits_namespaceObject = JSON.parse('{"readsInFreeTime":{"question":"Liest du in Deiner Freizeit Bücher? (Mangas sind Bücher.)","answers":{"YES":"Ja","NO":"Nein"}},"nativeSpeaker":{"question":"Ist Deutsch deine Muttersprache?","answers":{"YES":"Ja","NO":"Nein"}},"readingSkill":{"question":"Kannst du gut und flüssig lesen oder ist das Lesen für dich noch anstrengend?","answers":{"LOW":"Lesen ist für mich schwierig. Ich muss Sätze manchmal zweimal lesen, um sie zu verstehen.","GOOD":"Ich kann gut lesen. Nur bei fremden Texten und unbekannten Wörtern habe ich Schwierigkeiten.","FLUENT":"Ich kann flüssig lesen, auch fremde Texte."}},"booksReadYearly":{"question":"Wie viele Bücher liest du pro Jahr?","answers":{"ZERO_TO_FIVE":"0 bis 5","FIVE_TO_TEN":"6 bis 10","TEN_TO_FIFTEEN":"11 bis 15","MORE_THAN_FIFTEEN":"mehr als 15"}},"readingRelatives":{"question":"Wer aus Deiner Familie liest gerne? (Mehrfachantworten möglich.)","answers":{"FATHER":"Vater","MOTHER":"Mutter","SIBLING":"Geschwister","GRANDMOTHER":"Opa","GRANDFATHER":"Oma","NONE":"niemand"}}}');
;// CONCATENATED MODULE: ./src/locales/de/validation.json
var validation_namespaceObject = JSON.parse('{"notEmpty":"Das Feld darf nicht leer sein.","boolean":"Dieses Feld muss aktiviert werden.","email":"Ungültige E-Mail-Adresse.","passwordMinLength":"Das Password muss mindestens {{count}} Zeichen haben.","passwordRepeat":"Die Passwörter stimmen nicht überein."}');
;// CONCATENATED MODULE: ./src/locales/de/index.ts












;// CONCATENATED MODULE: ./src/locales/index.ts



// EXTERNAL MODULE: ./src/utilities/bookStack.ts
var bookStack = __webpack_require__(70545);
// EXTERNAL MODULE: ./src/utilities/Format/number.ts
var number = __webpack_require__(42729);
;// CONCATENATED MODULE: ./src/i18n.ts

var ref, ref1, ref2, ref3;

// eslint-disable-next-line import/no-internal-modules






i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({
    resources: {
        de: de_namespaceObject
    },
    lng: "de",
    fallbackLng: "de",
    defaultNS: "common"
});
(ref = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref === void 0 ? void 0 : ref.add("unit", function(value, lng, options) {
    return (0,number/* formatUnit */.A)(value, lng || options.fallbackLng);
});
(ref1 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref1 === void 0 ? void 0 : ref1.add("stacksize", function(value) {
    if (typeof value !== "number") {
        throw new Error("value passed is not a number");
    }
    return (0,bookStack/* getStackHeightInMM */.V)(value).toString(10);
});
(ref2 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref2 === void 0 ? void 0 : ref2.add("parsedate", function(value) {
    if (typeof value === "undefined") {
        console.error("undefined passed to parsedate-formatter");
    }
    if ((0,_instanceof/* default */.Z)(value, Date)) {
        return value;
    }
    return (0,parseISO/* default */.Z)(value);
});
(ref3 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref3 === void 0 ? void 0 : ref3.add("datetorelative", function(value, _lng) {
    if (!(0,_instanceof/* default */.Z)(value, Date)) {
        console.error("non-date passed to datetorelative-formatter");
        return "";
    }
    return (0,formatRelative/* default */.Z)(value, new Date(), {
        locale: de/* default */.Z
    });
});
/* harmony default export */ var src_i18n = ((/* unused pure expression or super */ null && (i18n)));



/***/ }),

/***/ 18115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/i18n.ts + 12 modules
var i18n = __webpack_require__(92869);
;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageIntroText.tsx





var HomepageIntroText = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        py: 75,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            position: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "xl",
                weight: 600,
                align: "center",
                sx: {
                    maxWidth: 600
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                    ns: "page_homepage",
                    i18nKey: "intro.text"
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 2 modules
var Box = __webpack_require__(74459);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ThemeIcon/ThemeIcon.js + 1 modules
var ThemeIcon = __webpack_require__(5044);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconNumber1.js
var IconNumber1 = __webpack_require__(91090);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconNumber2.js
var IconNumber2 = __webpack_require__(27685);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconNumber3.js
var IconNumber3 = __webpack_require__(74091);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
;// CONCATENATED MODULE: ./src/components/Default/Homepage/IntroSvg.tsx



var IntroSvg = function(param) {
    var className = param.className;
    (0,react.useEffect)(function() {
        if (false) {}
        var t = gsap/* default.timeline */.ZP.timeline();
        t.from("#intro_background_right", {
            xPercent: -100
        }).from("#intro_background_left", {
            xPercent: 100
        }, "<").from("#intro_foreground", {
            xPercent: 100
        }, "<+=50%").from("#intro_stars", {
            opacity: 0,
            duration: 0.5
        }).fromTo("#intro_stars > *", {
            opacity: 0
        }, {
            opacity: 1,
            duration: 1.5,
            stagger: {
                each: 0.25,
                from: "random"
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 3600 1703",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Page-1",
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "intro",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "intro_background",
                        transform: "matrix(-1 0 0 1 3600 380)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "intro_background_right",
                                fill: "#9DEEFF",
                                d: "M0 285c40 76 211 148 363 83C599.57 266.84 787.51-21.74 1145 2c512 34 444.34 553.92 678 724 294 214 401 400 415 597H0V285z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "intro_background_left",
                                fill: "#93BEFF",
                                d: "M2098 1323c22.726-243 993.758-525 1502-536v536H2098z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        transform: "translate(1537)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "intro_foreground",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "intro_books",
                                    transform: "translate(240.2 630)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Group",
                                            transform: "translate(719.8)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#3797DB",
                                                    d: "M22.34 562.47l185.11 74.34L436.59 66.25 280.12 3.41c-15.82-6.35-33.79 1.32-40.14 17.14L22.34 562.47z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    id: "Rectangle",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#D1EAF2",
                                                            d: "M41.892 28.502h359.96v506.1H41.892z",
                                                            transform: "rotate(-169.95 223.719 302.552)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M176.82 81.855h160.74v3.61H176.82z",
                                                            transform: "rotate(-169.95 259.036 104.66)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M144.642 72.838h228.28v3.61h-228.28z",
                                                            transform: "rotate(-169.95 260.629 95.643)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M112.089 119.161h276.96v3.61h-276.96z",
                                                            transform: "rotate(-169.95 252.416 141.966)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M109.055 136.252h276.96v3.61h-276.96z",
                                                            transform: "rotate(-169.95 249.382 159.057)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M102.997 170.434h276.96v3.61h-276.96z",
                                                            transform: "rotate(-169.95 243.323 193.24)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M99.963 187.525h276.96v3.61H99.963z",
                                                            transform: "rotate(-169.95 240.29 210.33)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M96.928 204.616h276.96v3.61H96.928z",
                                                            transform: "rotate(-169.95 237.255 227.421)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M83.602 279.784h276.96v3.61H83.602z",
                                                            transform: "rotate(-169.95 223.928 302.59)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M80.456 297.504h276.96v3.61H80.456z",
                                                            transform: "rotate(-169.95 220.782 320.309)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M77.332 315.216h276.96v3.61H77.332z",
                                                            transform: "rotate(-169.95 217.658 338.02)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M74.176 332.946h276.96v3.61H74.176z",
                                                            transform: "rotate(-169.95 214.502 355.75)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M71.04 350.665H348v3.61H71.04z",
                                                            transform: "rotate(-169.95 211.366 373.47)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M67.884 368.395h276.96v3.61H67.884z",
                                                            transform: "rotate(-169.95 208.21 391.2)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M64.738 386.115h276.96v3.61H64.738z",
                                                            transform: "rotate(-169.95 205.064 408.92)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    id: "Rectangle",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#E1F9FF",
                                                            d: "M58.528 38.02h359.96v506.1H58.528z",
                                                            transform: "rotate(-165.26 245.948 305.359)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M209.521 94.924h160.74v3.61h-160.74z",
                                                            transform: "rotate(-165.26 297.331 111.018)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M178.076 86.08h228.28v3.61h-228.28z",
                                                            transform: "rotate(-165.26 299.656 102.174)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M141.756 131.573h276.96v3.61h-276.96z",
                                                            transform: "rotate(-165.26 287.676 147.666)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M137.343 148.36h276.96v3.61h-276.96z",
                                                            transform: "rotate(-165.26 283.263 164.453)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M128.513 181.924h276.96v3.61h-276.96z",
                                                            transform: "rotate(-165.26 274.433 198.017)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M124.09 198.698h276.96v3.61H124.09z",
                                                            transform: "rotate(-165.26 270.01 214.792)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M119.674 215.495h276.96v3.61h-276.96z",
                                                            transform: "rotate(-165.26 265.594 231.589)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M100.239 289.319h276.96v3.61h-276.96z",
                                                            transform: "rotate(-165.26 246.16 305.412)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M95.655 306.727h276.96v3.61H95.655z",
                                                            transform: "rotate(-165.26 241.576 322.82)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#7772D6",
                                                            d: "M91.074 324.125h276.96v3.61H91.074z",
                                                            transform: "rotate(-165.26 236.995 340.218)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M86.481 341.533h276.96v3.61H86.481z",
                                                            transform: "rotate(-165.26 232.401 357.626)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M81.91 358.931h276.96v3.61H81.91z",
                                                            transform: "rotate(-165.26 227.83 375.025)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M77.309 376.349h276.96v3.61H77.309z",
                                                            transform: "rotate(-165.26 223.229 392.443)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fill: "#55769F",
                                                            d: "M72.745 393.75h276.96v3.61H72.745z",
                                                            transform: "rotate(-165.26 218.665 409.843)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#62BDF3",
                                                    d: "M92.57 590.68l372.67 149.67L682.6 199.13 369.44 5.95C351.84-4.91 328.7 2.71 321 21.9L92.57 590.68z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Path",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#9ED16F",
                                                    d: "M283.11 110.88l67.52-19.78C362.52 41.96 369.65.11 369.65.11 288.18 3.4 225.48 28.33 177.26 63.77l-9.98 80.25-21.54-53.81C31.89 198.78 18.57 366.39 18.57 366.39s229.15-89.66 272.82-126.61c16.86-14.27 32.37-53.25 45.05-95.73-22.8-12.28-53.35-33.18-53.35-33.18l.02.01z",
                                                    transform: "translate(977.8 423)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#96A65F",
                                                    d: "M369.65.11S101.49 210.46 18.57 366.4c0 0 229.15-89.66 272.82-126.61 16.86-14.27 32.37-53.25 45.05-95.73-22.8-12.28-53.35-33.18-53.35-33.18l67.52-19.78C362.5 41.96 369.63.11 369.63.11h.02z",
                                                    transform: "translate(977.8 423)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#7772D6",
                                                    d: "M415.7 206.57c-47.6-13.69-92.39-15.74-133.68-10.15-7.71 17.71-17.37 38.7-17.37 38.7l-10.82-33.62C99.08 236.32.43 373.35.43 373.35c103.78 31.6 183.5 26.34 243.99 4.44.41-12.91.74-32.09.74-32.09l18.4 24.35c28.39-12.74 52.02-29.14 71.53-46.62-9.67-12.6-20.19-27.15-20.19-27.15l38.06 9.71c45.98-48.84 62.74-99.42 62.74-99.42z",
                                                    transform: "translate(977.8 423)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#45258F",
                                                    d: "M244.42 377.79c.41-12.91.74-32.09.74-32.09l18.4 24.35c28.39-12.74 52.02-29.14 71.53-46.62-9.67-12.6-20.19-27.15-20.19-27.15l38.06 9.71c45.98-48.84 62.74-99.42 62.74-99.42C231.99 234.68.44 373.35.44 373.35c103.78 31.6 183.5 26.34 243.99 4.44h-.01z",
                                                    transform: "translate(977.8 423)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Path",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#7772D6",
                                                    d: "M35.92 5.11H10.44C14.61 2.26 19.82.55 25.5.55h638.43c33.4 0 60.48 24 60.48 53.61v34.05c0 29.61-27.08 53.61-60.48 53.61l-631.29-.19L35.93 5.1l-.01.01z",
                                                    transform: "translate(186.8 214)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#D1EAF2",
                                                    d: "M670.85 88.22V54.17c0-29.61-27.08-53.61-60.48-53.61h13.71c33.4 0 60.48 24 60.48 53.61v34.05c0 29.61-27.08 53.61-60.48 53.61h-13.53c33.32-.09 60.3-24.06 60.3-53.61zm-149.52 0V54.17c0-29.61-27.08-53.61-60.48-53.61h13.71c33.4 0 60.48 24 60.48 53.61v34.05c0 29.61-27.08 53.61-60.48 53.61h-13.53c33.32-.09 60.3-24.06 60.3-53.61z",
                                                    transform: "translate(186.8 214)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#45258F",
                                                    d: "M398.37.68c31.94 0 57.84 22.95 57.84 51.27v38.48c0 28.32-25.89 51.27-57.84 51.27H.93v-8.61h1.64l101.04-8.48 20.42-71.02S84.61 14.35 82.04 13.33C79.47 12.32 2.57 9.25 2.57 9.25H.93V.67h397.44v.01z",
                                                    transform: "translate(186.8 214)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#D1EAF2",
                                                    d: "M26.71 70.94C26.71 29.42 2.5 9.29 2.5 9.29h387.73c29.34 0 53.12 21.08 53.12 47.09V86c0 26.01-23.79 47.09-53.12 47.09H2.5s24.21-9.88 24.21-62.16v.01z",
                                                    transform: "translate(186.8 214)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#DAEEF7",
                                                    d: "M443.36 56.38V86c0 3.9-.54 7.67-1.55 11.29-13.08-28.36-38.14-55.68-85.85-64.46C244.57 12.32 2.51 9.28 2.51 9.28h387.73c29.34 0 53.12 21.08 53.12 47.09v.01z",
                                                    style: {
                                                        mixBlendMode: "multiply"
                                                    },
                                                    transform: "translate(186.8 214)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Path",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#45258F",
                                                    d: "M40.43 6.49H11.59A28.153 28.153 0 0128.63.78h722.58c37.81 0 68.45 30.04 68.45 67.11v42.62c0 37.06-30.65 67.11-68.45 67.11l-714.49-.24L40.44 6.49h-.01z",
                                                    transform: "translate(192.8 495)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#2D185D",
                                                    d: "M450.66.94c36.15 0 65.46 28.73 65.46 64.17v48.17c0 35.44-29.31 64.17-65.46 64.17H.84v-10.78H2.7l114.36-10.62 23.11-88.89S95.56 18.04 92.65 16.77C89.74 15.5 2.7 11.66 2.7 11.66l-1.86-.02V.92h449.82v.02z",
                                                    transform: "translate(192.8 495)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#D1EAF2",
                                                    d: "M30.01 88.89c0-51.97-27.4-77.17-27.4-77.17h438.83c33.21 0 60.13 26.39 60.13 58.95v37.08c0 32.55-26.92 58.94-60.13 58.94H2.61s27.4-12.36 27.4-77.8z",
                                                    transform: "translate(192.8 495)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#DAEEF7",
                                                    d: "M501.57 70.66v37.08c0 4.87-.62 9.61-1.75 14.14-14.8-35.5-43.17-69.69-97.17-80.69C276.58 15.52 2.61 11.72 2.61 11.72h438.83c33.21 0 60.13 26.39 60.13 58.95v-.01z",
                                                    style: {
                                                        mixBlendMode: "multiply"
                                                    },
                                                    transform: "translate(192.8 495)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Path",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#9ED16F",
                                                    d: "M780.48 5h28.85C804.61 2.17 798.7.47 792.28.47H69.42C31.6.47.94 24.31.94 53.72v33.82c0 29.41 30.66 53.25 68.48 53.25l714.77-.19L780.47 5h.01z",
                                                    transform: "translate(255.8 355)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#96A65F",
                                                    d: "M370.09.59c-36.17 0-65.49 22.8-65.49 50.92v38.22c0 28.12 29.32 50.92 65.49 50.92h450v-8.55h-1.86l-114.4-8.42-23.12-70.54s44.63-38.98 47.54-39.98c2.91-1.01 89.99-4.06 89.99-4.06l1.86-.02V.58h-450l-.01.01z",
                                                    transform: "translate(255.8 355)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#D1EAF2",
                                                    d: "M790.91 70.38c0-41.24 27.41-61.23 27.41-61.23h-439c-33.22 0-60.15 20.94-60.15 46.77v29.42c0 25.83 26.93 46.77 60.15 46.77h439s-27.41-9.81-27.41-61.73z",
                                                    transform: "translate(255.8 355)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#DAEEF7",
                                                    d: "M319.16 55.92v29.42c0 3.87.62 7.62 1.75 11.22 14.81-28.17 43.18-55.3 97.2-64.03 126.12-20.37 400.2-23.39 400.2-23.39h-439c-33.22 0-60.15 20.94-60.15 46.77v.01z",
                                                    style: {
                                                        mixBlendMode: "multiply"
                                                    },
                                                    transform: "translate(255.8 355)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#96A65F",
                                                    d: "M133.37 87.54V53.72c0-29.41 30.66-53.25 68.48-53.25h-68.64c-37.82 0-68.48 23.84-68.48 53.25v33.82c0 29.41 30.66 53.25 68.48 53.25l67.73-.02c-37.4-.38-67.57-24.06-67.57-53.23z",
                                                    opacity: "0.5",
                                                    transform: "translate(255.8 355)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M1083.89 678.04h36.17c-5.92-3.16-13.32-5.06-21.38-5.06H192.46c-47.41 0-85.85 26.64-85.85 59.49v37.79c0 32.86 38.44 59.49 85.85 59.49l896.09-.21-4.66-151.5z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3B77BE",
                                            d: "M569.41 673.12c-45.34 0-82.1 25.47-82.1 56.89v42.71c0 31.42 36.76 56.89 82.1 56.89h564.15v-9.55h-2.33l-143.42-9.41-28.99-78.81s55.95-43.55 59.6-44.67c3.65-1.12 112.81-4.53 112.81-4.53l2.33-.02v-9.5H569.41z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D1EAF2",
                                            d: "M1096.97 751.09c0-46.08 34.36-68.41 34.36-68.41H580.96c-41.65 0-75.41 23.4-75.41 52.26v32.87c0 28.86 33.76 52.26 75.41 52.26h550.37s-34.36-10.96-34.36-68.98z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#DAEEF7",
                                            d: "M505.55 734.93v32.87c0 4.32.77 8.52 2.2 12.53 18.56-31.47 54.14-61.79 121.86-71.54 158.12-22.76 501.71-26.13 501.71-26.13H580.95c-41.65 0-75.41 23.4-75.41 52.26l.01.01z",
                                            style: {
                                                mixBlendMode: "multiply"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#62BDF3",
                                            d: "M7.03 828.68h1314.25c3.88 0 7.03 3.15 7.03 7.03v3.23c0 3.88-3.15 7.03-7.03 7.03H7.03c-3.88 0-7.03-3.15-7.03-7.03v-3.23c0-3.88 3.15-7.03 7.03-7.03z",
                                            transform: "rotate(-180 664.155 837.325)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M1336.37 258.88l-253.73-145.12-34.29 67.93 259.62 137.35z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "intro_stars",
                                    transform: "translate(.78 44.74)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#7772D6",
                                            d: "M1532.7 174.91s2 19.73 17.57 21.1c-15.57 1.37-17.57 21.1-17.57 21.1s-2-19.73-17.57-21.1c15.57-1.37 17.57-21.1 17.57-21.1z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FF5B7E",
                                            d: "M1641.81 894.86s3 29.6 26.36 31.65c-23.36 2.05-26.36 31.65-26.36 31.65s-3-29.6-26.36-31.65c23.36-2.05 26.36-31.65 26.36-31.65z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#9ED16F",
                                            d: "M1801.45 340.2s2.67 26.28 23.41 28.1c-20.74 1.82-23.41 28.1-23.41 28.1s-2.67-26.28-23.41-28.1c20.74-1.82 23.41-28.1 23.41-28.1zM333.97 1011.41s1.79 17.69 15.75 18.91c-13.96 1.22-15.75 18.91-15.75 18.91s-1.79-17.69-15.75-18.91c13.96-1.22 15.75-18.91 15.75-18.91z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M1475.37 514.27s1.79 17.65 15.72 18.87c-13.93 1.22-15.72 18.87-15.72 18.87s-1.79-17.65-15.72-18.87c13.93-1.22 15.72-18.87 15.72-18.87zM1232.9 51.01s1.79 17.65 15.72 18.87c-13.93 1.22-15.72 18.87-15.72 18.87s-1.79-17.65-15.72-18.87c13.93-1.22 15.72-18.87 15.72-18.87zm-853.52 292.6s2.34 23.09 20.57 24.69c-18.23 1.6-20.57 24.69-20.57 24.69s-2.34-23.1-20.57-24.69c18.22-1.6 20.57-24.69 20.57-24.69zM271 701.92s3.43 33.84 30.13 36.18c-26.7 2.34-30.13 36.18-30.13 36.18s-3.43-33.84-30.13-36.18c26.7-2.34 30.13-36.18 30.13-36.18zm904.09-389.83s2.67 26.28 23.41 28.1c-20.74 1.82-23.41 28.1-23.41 28.1s-2.67-26.28-23.41-28.1c20.74-1.82 23.41-28.1 23.41-28.1z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#7772D6",
                                            d: "M1778.05 681.89s2.67 26.28 23.41 28.1c-20.74 1.82-23.41 28.1-23.41 28.1s-2.67-26.28-23.41-28.1c20.74-1.82 23.41-28.1 23.41-28.1zM649.15 230.3s1.9 18.72 16.67 20.02c-14.78 1.3-16.67 20.02-16.67 20.02s-1.9-18.72-16.67-20.02c14.78-1.29 16.67-20.02 16.67-20.02zm-89.2 345.25s3.04 29.99 26.7 32.06c-23.66 2.08-26.7 32.06-26.7 32.06s-3.04-29.99-26.7-32.06c23.66-2.07 26.7-32.06 26.7-32.06z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#9ED16F",
                                            d: "M18.23 463.71s2.08 23.79 18.24 25.43c-16.16 1.65-18.24 25.43-18.24 25.43S16.15 490.78 0 489.14c16.16-1.65 18.23-25.43 18.23-25.43zM684.31 0s2.08 23.86 18.29 25.51c-16.21 1.65-18.29 25.51-18.29 25.51s-2.08-23.86-18.29-25.51C682.22 23.86 684.31 0 684.31 0z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "intro_person",
                                    transform: "translate(801 197)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#DAEEF7",
                                            d: "M140.41 326.55l40.94 3.29-13.21 33.12-20.66-1.66-8.6 27.61c-2.1-.96-3.64-1.68-3.95-1.89-.63-.42-2.91-14.12-4.92-27.05l10.41-33.41-.01-.01z",
                                            style: {
                                                mixBlendMode: "multiply"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#45258F",
                                            d: "M163.77 631.09v14.43c0 1.19.96 2.16 2.15 2.16h33.69c2.44 0 3.37-3.19 1.31-4.51l-18.9-12.08s-7.41 5.44-18.25 0z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#EFAC7F",
                                            d: "M97.63 19.38c-.49.19-1.01-.24-.9-.75.84-4.01 3.42-16.63 2.45-17.08-1.15-.53-3.73 10.7-4.9 10.83-1.17.14 1.62-10.75.29-11.12-1.33-.37-3.54 9.64-4.15 9.68-.61.04.48-9.78-.17-10.46-.65-.68-3.09 9.66-3.82 9.91-.73.26-1.42-7.44-2.09-7.45-.67-.02-1.11-.14-4.52 17.63 0 0-.2 6.51-1.35 8.04l2.56 5.23 7.95.26s17.27-15.62 17.13-16.58c-.13-.91-.9-1.12-8.48 1.85v.01zm81.81 3.93c.35.4 1 .25 1.14-.26 1.08-3.95 4.54-16.37 5.61-16.32 1.27.05-1.55 11.22-.57 11.88.98.66 3.46-10.31 4.81-10.03 1.35.28-1.25 10.2-.72 10.51.53.31 4.03-8.92 4.92-9.24.89-.31-1.65 10-1.12 10.57.53.57 4.65-5.97 5.25-5.68.6.29 1.05.38-4.01 17.75 0 0-2.79 5.89-2.46 7.77l-4.67 3.49-7.2-3.39s-8.25-21.78-7.69-22.56c.53-.74 1.31-.59 6.7 5.51h.01zm-63.17 142.3l.13 30.38-29.51-4.55 4.92-34.16z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D19369",
                                            d: "M89.54 173l2.27-15.73 24.49 11.21v6c-5.89 1.44-16.93 2.73-26.76-1.48z",
                                            opacity: "0.6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#45258F",
                                            d: "M62.95 629.48v15.83c0 1.31-1.06 2.37-2.37 2.37H23.52c-2.68 0-3.7-3.5-1.44-4.94l20.79-13.25s8.16 5.96 20.08 0v-.01zM29.1 360.56c.07-3.39-8.74 6.6-8.57 3.89 3.46-56.21 113.28-9.08 113.28-9.08l26.81 19.67 30.26 260.49s-16.43 4.76-27.24.87L96.62 413.18l-8.24-3.17s-36.65-25.57-59.28-49.45z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Group",
                                            transform: "translate(19 351)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#06BFAD",
                                                    d: "M1.4 15.75zm-.09 2.05c-.03.7-.05 1.43-.08 2.17.02-.74.05-1.46.08-2.17zm-.08 2.46zm.3-6.8c-.04.61-.07 1.24-.1 1.88.03-.64.07-1.28.1-1.88z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#2D185D",
                                                    d: "M1.54.69c22.63 23.88 67.84 58.33 67.84 58.33l8.24 3.17-8.24-3.17L43.9 284.55s-18.16 3.46-28.54-2.16c0 0-15.3-214.67-13.82-281.69V.69z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#06BFAD",
                                                    d: "M171.88 284.54s-7.08 2.05-14.99 2.36c7.92-.31 14.99-2.36 14.99-2.36zm-24.07 1.74c.73.15 1.47.27 2.22.37-.75-.09-1.49-.22-2.22-.37zm9.07.62c-1.89.07-3.82.05-5.72-.13 1.9.17 3.83.2 5.72.13z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#2D185D",
                                            d: "M160.61 375.05l4.32 37.18c-11.43 4.42-39.29 9.15-60.28-36.76-6.62-14.48-8.32-24.9-7.1-32.39 20.1 5.38 36.25 12.3 36.25 12.3l26.81 19.67z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D1EAF2",
                                            d: "M59.85 223.3c1.27 0 20.29-43.11 20.29-43.11 16.27 11.41 38.36 3.49 38.36 3.49s88.87 162.62 29.27 187.98c-59.6 25.36-115.81-5.5-115.81-5.5s-12.68-32.97-12.68-34.24c0-1.27 39.31-108.62 40.58-108.62h-.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#9ED16F",
                                            d: "M175.66 40.71s3.85 77.15-3.38 91.3c-23.99 46.92-53.78 51.67-53.78 51.67s-10.25 164.1-1.8 203.41c0 0 28.11 8.67 69.53-10.78 0 0-31.7-127.22-30.01-143.28 0 0 50.72-45.23 52.41-98.48 1.69-53.26-12.26-100.59-12.26-100.59l-20.71 6.76v-.01zM38.93 381.17s3.17-61.08 17.12-118.98c13.95-57.9 24.09-82 24.09-82-18.7-20.6-15.6-39.23-13.95-63.4 1.9-27.9 29.16-83.69 29.16-83.69L76.96 21.05c-88.12 105.88-39.31 190.2-39.31 190.2S4.68 327.91.24 363.41c0 0 17.54 10.14 38.67 17.75l.02.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#96A65F",
                                            d: "M155.36 232.85c-1.06-.75-2.32-1.9-3.54-3.37-3.74-4.51-5.67-9.59-7.01-15.26.81 2.42 2.98 9.46 7.54 14.82 2.05 2.33 3.13 3.13 4.12 3.76-.16.15-.25.23-.25.23l-.03.33c-1.17.24-3.23.32-6.7-1.57-2.15-1.13-3.86-2.53-5.63-4.04 1.16.83 3.57 2.57 5.84 3.64 1.58.78 3.9 1.59 5.66 1.47v-.01zM38.33 210.87c1.51-.96 2.82-2.33 4.03-3.71 3.74-4.39 5.79-9.58 7.54-14.82-1.33 5.65-3.26 10.73-7.01 15.26-1.22 1.46-2.46 2.6-3.54 3.37.83.06 1.82-.1 2.48-.29 1.09-.27 2.16-.68 3.18-1.18 2.12-.99 4.21-2.48 5.84-3.64-1.58 1.34-3.38 2.86-5.64 4.04-1.02.56-2.1 1.02-3.24 1.36-1.15.29-2.31.54-3.61.18l-.67-.18.64-.4v.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#5E2E0D",
                                            d: "M73.94 103.62l-1.79 20.84 3.3 2.08 6.09-25.39z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D19369",
                                            d: "M78.37 122.31c.91 4.72-1.42 9.14-5.2 9.86-3.78.73-7.58-2.52-8.48-7.24-.91-4.72 1.42-9.14 5.2-9.86 3.78-.73 7.58 2.52 8.48 7.24z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#EFAC7F",
                                            d: "M72.96 141.58c-.97-6.04-.83-12.21-.29-17.51.12-1.14.16-2.28.19-3.42.11-4.62 1.07-9.34 3.09-14 6.5-14.97 22.37-24.06 38.57-22.05 21.82 2.71 36.2 23.24 32 44.23 2.54-.81 5.16-.59 7.21.87 3.94 2.8 4.3 9.06.8 13.99s-9.53 6.65-13.47 3.85c-.55-.39-1.02-.85-1.43-1.36-5.39 17.49-22.79 28.35-40.28 24.55-13.28-2.89-24.24-13.9-26.4-29.15h.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#333",
                                            d: "M113.31 124.91c-.86 2.16.7 4.48 3.06 4.47 1.29 0 2.48-.82 2.95-2.02.86-2.16-.7-4.49-3.07-4.48-1.29 0-2.48.83-2.95 2.03h.01zm-27.64-4.14c-.86 2.16.7 4.49 3.07 4.47 1.29 0 2.48-.83 2.95-2.03.86-2.16-.7-4.48-3.07-4.47-1.29 0-2.48.83-2.95 2.03z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D19369",
                                            d: "M109.01 147.62c-1.71.86-3.64 1.49-5.22 1.79-1.8.35-3.64.46-5.43.21-1.8-.24-3.53-.87-5.11-1.78-1.57-.93-2.97-2.15-4.24-3.51 1.29 1.82 2.46 2.88 3.98 3.93 1.57 1.03 3.24 1.69 5.28 2 1.89.25 3.81.11 5.63-.37 1.82-.48 3.57-1.21 5.11-2.27z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#5E2E0D",
                                            d: "M110.68 118.32c1.69-.3 3.29-.49 4.85-.52 1.56-.03 3.07.14 4.51.54 1.43.41 2.85.94 4.15 1.8 1.77 1.01 3.05 2.25 3.98 2.85-.59-1.5-1.55-3.28-2.85-4.32-1.26-1.26-2.93-2.13-4.68-2.61-1.76-.48-3.62-.49-5.35-.09-1.72.42-3.35 1.16-4.62 2.35h.01zm-12.91-2.13c-.82-1.53-2.13-2.76-3.62-3.71a11.04 11.04 0 00-5.09-1.63c-1.81-.1-3.67.18-5.26.97-1.57.57-3.05 1.96-4.08 3.18 1.16-.3 2.62-1.03 4.68-1.43 1.51-.39 3.02-.45 4.51-.38 1.49.09 2.98.41 4.45.94 1.47.53 2.92 1.22 4.43 2.05l-.02.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D19369",
                                            d: "M103.4 120.29c-1.52 1.43-2.92 2.98-4.23 4.59-1.32 1.61-2.55 3.3-3.64 5.11-.62 1.08-1.41 2.53-1.59 3.76-.11.68-.05 1.34 1.09 2.46.75.79 1.59 1.44 2.45 2.03.87.58 1.77 1.12 2.72 1.56-1.58-1.35-3.17-2.7-4.42-4.25-.2-.24-.58-.8-.71-1.11-.07-.23.05-.73.22-1.16.34-.89.83-1.79 1.35-2.65 1.03-1.75 2.2-3.45 3.34-5.17 1.16-1.71 2.32-3.42 3.44-5.18l-.02.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#5E2E0D",
                                            d: "M77.82 81.35s-10.95-2.11 2.54-8.72c13.49-6.61 46.56-10.46 63.85 4.35 0 0 5.81-7.46 11.04-4.18 5.23 3.28-5.44 6.9-5.44 6.9s7.3 1.41 8.71 5.46c1.04 3-3.42 2.11-5.82 1.44 3.97 1.63 15.64 12.66.48 42.76-2.68-1.26-20.02-25.99-20.02-25.99s-34.86 11.45-28.51 1.95c0 0-40.63 10.22-30.78-8.2 0 0-14.98-2.25 3.96-15.77h-.01z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#5E2E0D",
                                            d: "M153.17 129.36s-2.63-2.01-6.65-.52c-4.02 1.49-6.57 10.51-6.57 10.51s-13.16 10.77-6.74-36.18c6.3-46.13 15.03 7.68 15.03 7.68l4.93 18.52v-.01z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "intro_trophy",
                                    transform: "translate(872)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M101.37 181.98l-60.15-4.29c-3.04-.22-5.34-2.86-5.12-5.9.22-3.04 2.86-5.34 5.9-5.12l60.15 4.28c3.04.22 5.34 2.86 5.12 5.9-.22 3.04-2.86 5.34-5.9 5.12v.01zM84.04.84l21.03 51.53 54.36 11.9-42.51 35.91 5.49 55.39-47.3-29.34-50.97 22.33 13.28-54.04L.43 52.94l55.5-4.07z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "intro_tropy_highlights",
                                            fill: "#3B77BE",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M84.04.84l-5.38 75.62 26.41-24.09z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M159.43 64.27L78.66 76.46l38.26 23.72zM78.66 76.46L55.93 48.87.43 52.94zm-54.52 72.1l54.52-72.1-41.24 18.06z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M122.41 155.57L78.66 76.46l-3.55 49.77z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#7772D6",
                                            d: "M24.219 181.058h91.62v32.2h-91.62z",
                                            transform: "rotate(4.08 70.03 197.158)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#CDD6E0",
                                            style: {
                                                mixBlendMode: "multiply"
                                            },
                                            d: "M67.329 165.586h3.52v91.62h-3.52z",
                                            transform: "rotate(-85.92 69.089 211.396)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#CDD6E0",
                                            style: {
                                                mixBlendMode: "multiply"
                                            },
                                            d: "M69.433 136.071h3.52v91.62h-3.52z",
                                            transform: "rotate(-85.92 71.193 181.881)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3B77BE",
                                            d: "M116.11 185.79l-90.02-6.41c-2.28-.16-4-2.14-3.83-4.42.16-2.28 2.14-4 4.42-3.83l90.02 6.41c2.28.16 4 2.14 3.83 4.42-.16 2.28-2.14 4-4.42 3.83z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#7772D6",
                                            d: "M115.8 223.92l-96.05-6.84c-.61-.04-1.07-.58-1.03-1.19l.43-6.03c.04-.61.58-1.07 1.19-1.03l96.05 6.84c.61.04 1.08.58 1.03 1.19l-.43 6.03c-.04.61-.58 1.07-1.19 1.03z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M86.53 205.86l-34.75-2.48a7.839 7.839 0 01-7.26-8.38 7.839 7.839 0 018.38-7.26l34.75 2.48c4.32.31 7.57 4.06 7.26 8.38a7.839 7.839 0 01-8.38 7.26z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#D9D9D9",
                                            d: "M51.96 200.77a5.225 5.225 0 01-4.75-6.23c.51-2.63 3.05-4.37 5.72-4.18l34.31 2.44c2.67.19 4.94 2.27 5.07 4.95.16 3.19-2.5 5.71-5.59 5.49l-34.75-2.48-.01.01z",
                                            style: {
                                                mixBlendMode: "multiply"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#3797DB",
                                            d: "M81.51 172.84l-19.33-1.38.13-1.79c.52-7.29 1.33-22.43 12.81-43.44 8.72 24.03 7.04 37.53 6.52 44.82l-.13 1.79z"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/Hero.tsx









var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        grid: (_obj = {
            display: "grid",
            gridTemplateColumns: "3fr 2fr",
            gridTemplateRows: "minmax(0, auto) minmax(0,1fr)",
            overflow: "hidden"
        }, (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("sm"), {
            gridTemplateColumns: "3fr 2fr"
        }), (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("md"), {
            gridTemplateRows: "2fr 3fr"
        }), _obj),
        headlines: (_obj1 = {
            gridColumn: "1/2",
            gridRow: "1/2",
            zIndex: 2
        }, (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("sm"), {
            justifySelf: "start",
            gridColumn: "1 / 3",
            gridRow: "1 / 2"
        }), (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("md"), {
            alignSelf: "end"
        }), _obj1),
        svg: (0,_define_property/* default */.Z)({
            gridColumn: "1/3",
            gridRow: "1/2",
            zIndex: 1
        }, theme.fn.largerThan("sm"), {
            marginTop: 50,
            alignSelf: "end",
            justifySelf: "end",
            gridRow: "1 / 3"
        }),
        introText: (_obj2 = {
            gridColumn: "1/3",
            gridRow: "2/3",
            zIndex: 2
        }, (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("sm"), {
            gridColumn: "1/2"
        }), (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("md"), {
            gridTemplateRows: "2fr 3fr",
            gridColumn: "1/3",
            gridRow: "2/3"
        }), _obj2),
        title: (0,_define_property/* default */.Z)({
            color: theme.colorScheme === "dark" ? theme.white : theme.black,
            fontSize: 44,
            lineHeight: 1.2,
            fontWeight: 900
        }, theme.fn.smallerThan("xs"), {
            fontSize: 28
        }),
        subtitle: (0,_define_property/* default */.Z)({
            fontSize: theme.fontSizes.md,
            marginTop: theme.spacing.md
        }, theme.fn.smallerThan("xs"), {
            marginTop: theme.spacing.xs,
            fontSize: theme.fontSizes.sm,
            hyphens: "auto"
        })
    };
});
var Hero = function() {
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            size: "lg",
            p: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                className: classes.grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        className: classes.headlines,
                        px: "md",
                        mt: 30,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                className: classes.title,
                                children: t("hero.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                className: classes.subtitle,
                                children: t("hero.subtitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroSvg, {
                        className: classes.svg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: "xl",
                        className: classes.introText,
                        mt: "xl",
                        px: "md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.a, {
                                spacing: "sm",
                                size: "sm",
                                type: "ordered",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNumber1/* default */.Z, {
                                                size: 12
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                                                ns: "page_homepage",
                                                i18nKey: "hero.steps.1"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNumber2/* default */.Z, {
                                                size: 12
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                                                ns: "page_homepage",
                                                i18nKey: "hero.steps.2"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNumber3/* default */.Z, {
                                                size: 12
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                                                ns: "page_homepage",
                                                i18nKey: "hero.steps.3"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/account/login",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            radius: "xl",
                                            size: "md",
                                            children: t("hero.cta.login")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/account/register",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "light",
                                            radius: "xl",
                                            size: "md",
                                            children: t("hero.cta.register")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(89814);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(56546);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/AspectRatio/AspectRatio.js + 1 modules
var AspectRatio = __webpack_require__(64577);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(39954);
;// CONCATENATED MODULE: ./src/utilities/coverUrlForBook.ts
function coverUrlForReadAchievement(readAchievement) {
    return coverUrlForBook(readAchievement.book, readAchievement.book.catalogId);
}
function coverUrlForBook(param, catalogId) {
    var isbn = param.isbn;
    // TODO: LibID Un-Hardcoden
    return isbn && catalogId && "https://www2.winbiap.de/coverservices-full/getcover.ashx?x13=".concat(isbn, "&catid=").concat(catalogId, "&libid=371&country=DE");
}

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageLatestBooksItem.tsx




var HomepageLatestBooksItem = function(param) {
    var isbn = param.isbn, catalogId = param.catalogId, title = param.title;
    var image = coverUrlForBook({
        isbn: isbn
    }, catalogId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatio/* AspectRatio */.o, {
        className: "latestBooks__book",
        ratio: 6 / 9,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
            src: image,
            alt: title || "Buchcover",
            fit: "cover",
            width: "100%",
            height: "100%",
            imageProps: {
                loading: "lazy"
            },
            styles: {
                figure: {
                    height: "100%",
                    flex: 1
                },
                imageWrapper: {
                    height: "100%",
                    flex: 1
                }
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageLatestBooksList.tsx









var HomepageLatestBooksList_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        column: (_obj = {
            width: "25%",
            flexShrink: 0
        }, (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("md"), {
            width: "15%"
        }), (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("lg"), {
            width: "12.5%"
        }), (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("xl"), {
            width: "10%"
        }), _obj),
        row: {
            "&:nth-of-type(odd)": (_obj1 = {
                transform: "translateX(-12.5%)"
            }, (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("md"), {
                transform: "translateX(-7.5%)"
            }), (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("lg"), {
                transform: "translateX(-6%)"
            }), (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("xl"), {
                transform: "translateX(-5%)"
            }), _obj1)
        },
        headline: (_obj2 = {
            lineHeight: 1.1,
            fontWeight: 900,
            fontSize: 50,
            gridColumn: "1 / 2",
            gridRow: "1 / 2",
            zIndex: 2,
            textAlign: "center"
        }, (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("sm"), {
            fontSize: 70
        }), (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("xl"), {
            fontSize: 100
        }), _obj2)
    };
});
var HomepageLatestBooksList = function(param) {
    var latestBooks = param.latestBooks;
    var ref = HomepageLatestBooksList_useStyles(), classes = ref.classes, cx = ref.cx;
    var chunkSize = 15;
    var chunks = (0,lodash.chunk)(latestBooks, chunkSize);
    (0,react.useEffect)(function() {
        if (false) {}
        gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
        var s = gsap/* default.utils.selector */.ZP.utils.selector("#latestBooks");
        /*
    gsap.fromTo(
      '#latestBooks__headline',
      {
        yPercent: -200,
      },
      {
        yPercent: 200,
        ease: 'none',
        scrollTrigger: {
          id: 'text',
          trigger: '#latestBooks',
          start: 'top center',
          end: 'bottom center',
          scrub: true,
          // markers: true,
        },
      }
    );

    s('.latestBooks__group').forEach((group) => {
      gsap.from(group.querySelectorAll('.latestBooks__book'), {
        scale: 0.9,
        opacity: 0,
        duration: 0.3,
        stagger: 0.1,
        scrollTrigger: {
          trigger: '#latestBooks',
          start: 'top center',
          end: 'bottom center',
          // markers: true,
        },
      });
    });
    */ gsap/* default.to */.ZP.to("#latestBooks__slider", {
            x: function() {
                return "-=".concat(document.querySelector("#latestBooks .latestBooks__book").clientWidth * chunkSize - document.documentElement.clientWidth);
            },
            ease: "none",
            duration: 20,
            scrollTrigger: {
                id: "books",
                trigger: "#latestBooks",
                start: "top center",
                end: "bottom center",
                // toggleActions: 'play pause resume pause',
                // end: 'bottom top',
                scrub: true
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        mt: 100,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleGrid/* SimpleGrid */.M, {
            cols: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    size: "md",
                    sx: {
                        gridArea: "1/1",
                        zIndex: 3,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                        sx: {
                            height: "100%"
                        },
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            id: "latestBooks__headline",
                            className: classes.headline,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                                ns: "page_homepage",
                                i18nKey: "currentBooks.headline"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    sx: {
                        zIndex: 2,
                        gridArea: "1/1",
                        background: "rgba(255 255 255 / 0.5)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    id: "latestBooks",
                    sx: {
                        overflow: "hidden",
                        gridArea: "1/1",
                        zIndex: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                        id: "latestBooks__slider",
                        children: chunks.map(function(chunk, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                noWrap: true,
                                className: cx("latestBooks__group", classes.row),
                                children: chunk.map(function(param, index) {
                                    var isbn = param.isbn, catalogId = param.catalogId, title = param.title;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        className: classes.column,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageLatestBooksItem, {
                                            isbn: isbn,
                                            catalogId: catalogId,
                                            title: title
                                        })
                                    }, "".concat(isbn, "-").concat(index));
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageNextStudent.tsx







var HomepageNextStudent_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        grid: (0,_define_property/* default */.Z)({
            display: "grid",
            gridTemplateColumns: "1fr",
            overflow: "hidden"
        }, theme.fn.largerThan("sm"), {
            gridTemplateRows: "minmax(0, auto) minmax(0,1fr)"
        }),
        headline: (0,_define_property/* default */.Z)({
            maxWidth: "10ch",
            lineHeight: 1.1,
            fontWeight: 900,
            fontSize: 35,
            gridColumn: "1 / 2",
            gridRow: "1 / 2",
            zIndex: 2
        }, theme.fn.largerThan("sm"), {
            fontSize: 70
        }),
        svg: (0,_define_property/* default */.Z)({
            gridColumn: "1 / 2",
            gridRow: "1 / 3",
            zIndex: 1,
            marginTop: 30
        }, theme.fn.largerThan("sm"), {
            marginTop: 0
        }),
        button: (0,_define_property/* default */.Z)({
            justifySelf: "center"
        }, theme.fn.largerThan("sm"), {
            gridColumn: "1 / 2",
            gridRow: "2 / 3",
            zIndex: 2,
            justifySelf: "start"
        })
    };
});
var HomepageNextStudent = function() {
    var classes = HomepageNextStudent_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        size: "md",
        mt: 100,
        sx: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            className: classes.grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: classes.headline,
                    children: t("nextStudent.headline")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    className: classes.svg,
                    src: "/static/statistics/next_student.svg",
                    alt: "Illustration eines lesenden Sch\xfclers"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/account/register",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        radius: "xl",
                        size: "lg",
                        mt: "xl",
                        className: classes.button,
                        children: t("nextStudent.cta")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/Default/Homepage/StackHeightSvg.tsx


var StackHeightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "500",
        height: "374",
        viewBox: "0 0 500 374",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Page-1",
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "10.2”-iPad",
                transform: "translate(-33 -1047)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "stack_height",
                    transform: "translate(33 1047)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Background_Complete",
                            fillRule: "nonzero",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Group",
                                    fill: "#EBEBEB",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M0 328.4H500V329.4H0z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M416.78 344.49H449.9V345.49H416.78z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M322.53 347.21H331.21999999999997V348.21H322.53z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M396.59 335.21H415.78V336.21H396.59z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M52.46 336.89H95.65V337.89H52.46z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M104.56 336.89H110.89V337.89H104.56z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            d: "M131.47 341.11H225.15V342.11H131.47z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Group",
                                    transform: "translate(236 30)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#E0E0E0",
                                            d: "M22.38 56.44H194.28V179.89H22.38z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#EBEBEB",
                                            d: "M20.38 56.45H192.29V179.9H20.38z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Rectangle",
                                            fill: "#FAFAFA",
                                            d: "M51.005 35.825H161.665V197.735H51.005z",
                                            transform: "rotate(90 106.335 116.78)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#E0E0E0",
                                            transform: "translate(36 69)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M2.57 22.12c-.05 0-.11 0-.17-.03a.506.506 0 01-.31-.64L6.21 9.71c.07-.2.24-.3.48-.33.21 0 .4.14.47.35l3.8 11.74a.51.51 0 01-.32.63.5.5 0 01-.63-.32L6.67 11.46 3.04 21.8c-.07.21-.27.33-.47.33v-.01z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M8.91 17.25h-3.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3.5c.28 0 .5.22.5.5s-.22.5-.5.5zM15.63 21.79c-.75 0-1.46-.44-2.12-1.31-.8-1.06-1.01-1.97-.61-2.71.9-1.7 4.7-1.54 5.13-1.51.28.02.49.25.47.53-.02.28-.25.49-.53.47-1.16-.06-3.71.09-4.19.99-.24.46.15 1.15.53 1.64.51.68 1.01.98 1.48.9 1.19-.2 2.42-2.68 2.92-4.19a.497.497 0 01.96.24c-.15.91-.3 3.61.97 3.99a.5.5 0 01.33.62c-.08.26-.36.42-.62.33-1.12-.34-1.56-1.45-1.71-2.55-.64 1.16-1.56 2.36-2.69 2.55-.11.02-.22.03-.33.03l.01-.02z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Shape",
                                                    d: "M3.5 43.48a.46.46 0 01-.33-.13.48.48 0 01-.17-.37V29.75c-.62.05-1.15.1-1.54.15a.503.503 0 01-.56-.43c-.04-.27.16-.52.43-.56.72-.09 7.07-.87 9.03.85.41.36.63.83.63 1.34 0 1.7-1.43 2.81-2.83 3.49 1.47.17 3.12.59 3.92 1.61.35.44.68 1.2.34 2.31-1.27 4.09-8.55 4.93-8.86 4.96h-.05l-.01.01zM4 29.69v12.72c1.67-.27 6.57-1.31 7.46-4.19.18-.57.12-1.03-.17-1.4-1.02-1.3-4.57-1.39-5.86-1.31-.26 0-.49-.17-.53-.43-.03-.26.14-.5.4-.55 1.3-.26 4.68-1.39 4.68-3.42 0-.23-.09-.42-.29-.59-.93-.82-3.54-.92-5.7-.82l.01-.01zM18.54 44.1c-.76 0-1.6-.19-2.48-.64a.5.5 0 01-.22-.67.49.49 0 01.67-.22c2.03 1.03 3.71.43 4.26-.65.46-.89 0-1.85-1.16-2.45-.9-.46-1.69-.46-2.43.03-1.24.81-1.88 2.65-1.98 3.25 0 .04 0 .09-.01.12v.03c-.08.57-.21.58-.42.61a.54.54 0 01-.55-.43c-.03-.14-.02-.36.04-.63.03-1.49 0-6.1-.05-9.07 0-.28.22-.5.49-.51.27 0 .5.22.5.49.04 3.08.07 5.22.07 6.71.32-.48.71-.93 1.16-1.27 1.09-.82 2.34-.89 3.64-.22 1.93 1 2.19 2.63 1.59 3.79-.51 1-1.66 1.72-3.12 1.72v.01z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M6.57 64.08c-1.61 0-3.2-1.08-4.28-2.45-1.73-2.2-2.49-5.7-.08-8.19 1.61-1.66 3.17-2.45 4.62-2.34 1.6.12 2.44 1.29 2.48 1.34.16.23.11.54-.12.7a.5.5 0 01-.7-.12c-.03-.04-.63-.85-1.76-.92-1.15-.08-2.43.61-3.81 2.04-2 2.07-1.37 4.94.15 6.88 1.21 1.54 3.15 2.66 4.78 1.71 3.35-1.96 3.71-2.83 3.72-2.86.04-.27.28-.44.56-.4.27.04.46.32.42.59-.05.35-.55 1.4-4.19 3.53-.58.34-1.19.49-1.79.49z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Shape",
                                                    d: "M17.68 64.29c-1.99 0-3.25-1.19-3.48-3.32-.16-1.52.17-2.57.98-3.11 1.57-1.05 4.22.35 4.51.51.24.13.33.44.2.68-.13.24-.44.33-.68.2-.66-.36-2.57-1.16-3.48-.56-.48.32-.66 1.05-.54 2.18.14 1.35.72 2.12 1.77 2.35 1.62.36 3.7-.69 3.99-1.08.04-.23.24-.4.48-.4s.5.21.51.49c.02.91-2.23 1.94-3.93 2.06-.12 0-.23.01-.34.01l.01-.01z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M5.25 86.1c-.88 0-1.5-.09-1.56-.1a.503.503 0 01-.42-.49V73.19c0-.28.22-.5.5-.5s.5.22.5.5v11.87c1.06.09 3.85.16 5.65-1.32 1.03-.85 1.59-2.1 1.65-3.72.12-2.97-1.31-4.8-2.53-5.82-2.06-1.71-4.98-2.36-6.61-1.98a.503.503 0 01-.22-.98c1.84-.42 5.08.21 7.47 2.19 1.4 1.16 3.03 3.25 2.89 6.63-.08 1.92-.76 3.41-2.02 4.45-1.62 1.33-3.82 1.59-5.29 1.59h-.01zM19.15 86.16c-2.38 0-3.89-1.28-4.2-2.71-.24-1.12.28-2.47 1.98-2.97.87-.25 1.7-.17 2.45.26.66.38 1.18.97 1.57 1.58v-9c0-.28.22-.5.5-.5s.5.22.5.5v11.34c0 .25-.19.46-.44.5a.509.509 0 01-.55-.37c0-.02-.64-2.36-2.08-3.17-.51-.29-1.06-.34-1.67-.17-.97.28-1.47.97-1.29 1.8.26 1.18 1.75 2.2 4.11 1.86.28-.03.53.15.57.42.04.27-.15.53-.42.57-.36.05-.7.08-1.03.08v-.02zM36.86 89.24h-.04a.497.497 0 01-.46-.54c2.74-38.04.03-87.01 0-87.5-.02-.28.2-.51.47-.53.28-.01.51.19.53.47.03.49 2.74 49.52 0 87.62-.02.26-.24.46-.5.46v.02zM140.66 67.35H47.4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h93.26c.28 0 .5.22.5.5s-.22.5-.5.5zM52.42 64.29c-.12 0-.23-.04-.33-.12a.505.505 0 01-.05-.71c.68-.79 16.74-19.36 21.78-21.93 5.24-2.67 20.49 17.43 22.21 19.73.17.22.12.53-.1.7-.22.17-.54.12-.7-.1-6.31-8.43-17.58-21.16-20.95-19.44-4.87 2.48-21.31 21.5-21.48 21.69-.1.11-.24.17-.38.17v.01zM138.22 62.06c-.14 0-.28-.06-.38-.17-4.75-5.52-17.87-19.84-21.54-19.61-3.7.19-14.93 11.64-18.94 16.04-.19.2-.5.22-.71.03-.2-.19-.22-.5-.03-.71.6-.66 14.77-16.11 19.63-16.36 4.87-.23 20.57 17.89 22.35 19.96.18.21.16.52-.05.71-.09.08-.21.12-.33.12v-.01zM88.61 48.68c-.12 0-.24-.04-.34-.13-.2-.19-.21-.5-.03-.71.16-.18 4.05-4.31 8.76-4.13 2.45.1 4.65 1.36 6.54 3.76.17.22.13.53-.08.7-.22.17-.53.13-.7-.08-1.69-2.15-3.64-3.29-5.79-3.37-4.25-.18-7.95 3.77-7.99 3.81-.1.11-.23.16-.37.16v-.01zM88.61 44.1c-.19 0-.36-.1-.45-.28l-2.47-5.11a.5.5 0 11.9-.44l2.47 5.11a.5.5 0 01-.45.72zM95.88 40.24h-.1a.495.495 0 01-.39-.59c.3-1.55 0-6.19 0-6.24-.02-.28.19-.51.47-.53.27 0 .51.19.53.47.01.2.32 4.82 0 6.5-.05.24-.26.4-.49.4l-.02-.01zM103.15 40.24a.496.496 0 01-.4-.8l3.41-4.42c.17-.22.48-.26.7-.09.22.17.26.48.09.7l-3.41 4.42c-.1.13-.25.19-.4.19h.01z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Shape",
                                                    d: "M138.22 17.25h-30.23c-.19 0-.36-.11-.45-.27a.489.489 0 01.04-.52c2.73-3.72 6.88-4.11 8.21-4.14.41-1.56 2.13-7.14 5.47-7.14 3.01 0 5.62 3.51 6.56 4.94.66-.62 2-1.54 4.39-1.48 3.56.03 6.19 7.14 6.47 7.96.05.15.03.32-.06.46-.09.13-.25.21-.41.21l.01-.02zm-29.17-1h28.44c-.93-2.32-3.09-6.6-5.29-6.62-2.98-.05-3.99 1.52-4.03 1.58-.09.15-.27.24-.43.23a.5.5 0 01-.42-.25c-.03-.05-2.94-5.02-6.06-5.02-2.5 0-4.16 4.88-4.59 6.76-.05.24-.27.39-.51.39-.05 0-4.2-.18-7.11 2.93zM79.72 28.58c-.18 0-.36-.1-.45-.28-.08-.17-.18-.32-.3-.47.04.07.06.15.06.24 0 .28-.22.5-.5.5h-29.8c-.24 0-.45-.18-.49-.42 0-.06-.22-1.4.71-2.37.65-.68 1.66-.98 3.01-.89.09-1.01.48-3.22 2.05-4.76 1.13-1.11 2.64-1.66 4.49-1.63 4.94.09 7.53 2.88 8.46 4.17.58-.61 1.74-1.46 3.82-1.55 2.48-.14 3.48 2.12 3.7 3.62 1.18.2 4.6.94 5.69 3.12.12.25.02.55-.22.67-.07.04-.15.05-.22.05h-.01zm-30.5-1h29.32c.11 0 .22.04.3.1-1.47-1.59-4.83-2-4.87-2.01a.501.501 0 01-.44-.46c0-.13-.27-3.19-2.71-3.09-2.66.12-3.44 1.63-3.45 1.64-.08.17-.25.27-.44.28a.55.55 0 01-.45-.26c-.09-.17-2.33-4.17-8.01-4.27-1.58-.03-2.84.42-3.77 1.33-1.76 1.73-1.79 4.57-1.79 4.6 0 .14-.06.28-.17.37-.11.1-.25.14-.39.12-1.27-.16-2.2.03-2.69.54-.33.34-.43.78-.45 1.1l.01.01z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    d: "M76.15 90.56a.505.505 0 01-.38-.83l17.88-21.36c.18-.21.49-.24.7-.06.21.18.24.49.06.7L76.53 90.37c-.1.12-.24.18-.38.18v.01zM98.3 90.56c-.25 0-.47-.19-.5-.45l-2.28-21.36c-.03-.27.17-.52.44-.55.28-.03.52.17.55.44L98.79 90c.03.27-.17.52-.44.55h-.05v.01z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            transform: "translate(41 171)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#E6E6E6",
                                                    d: "M3.13.18h17.89c.8 0 1.44.65 1.44 1.44v3.62H1.69V1.62c0-.8.65-1.44 1.44-1.44z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Rectangle",
                                                    fill: "#E0E0E0",
                                                    d: "M0.4 2.33H23.74V7.1H0.4z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            transform: "translate(115 150)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    transform: "translate(1)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#EBEBEB",
                                                            d: "M1.225 4.02H2.805V19.84H1.225z",
                                                            transform: "rotate(-2.34 2.015 11.93)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Path",
                                                            fill: "#E6E6E6",
                                                            d: "M0.85 0.98L0.87 4.25 2.57 4.18 2.32 0.92z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#E6E6E6",
                                                            d: "M0.791 3.999H2.661V4.9990000000000006H0.791z",
                                                            transform: "rotate(-2.34 1.726 4.449)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    transform: "translate(5 1)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#EBEBEB",
                                                            d: "M1.671 3.984H3.2510000000000003V19.804000000000002H1.671z",
                                                            transform: "rotate(7.45 2.46 11.894)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Path",
                                                            fill: "#E6E6E6",
                                                            d: "M3.16 0.93L2.62 4.15 4.3 4.37 4.61 1.12z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#E6E6E6",
                                                            d: "M2.492 4.063H4.362V5.063H2.492z",
                                                            transform: "rotate(7.45 3.427 4.513)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    transform: "translate(10)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#E6E6E6",
                                                            d: "M0.878 4.012H2.458V19.832H0.878z",
                                                            transform: "rotate(-2.33 1.668 11.922)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Path",
                                                            fill: "#F0F0F0",
                                                            d: "M0.5 0.98L0.52 4.25 2.22 4.18 1.97 0.92z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#F0F0F0",
                                                            d: "M0.435 4.011H2.305V5.011H0.435z",
                                                            transform: "rotate(-2.33 1.37 4.46)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    transform: "translate(3)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#E6E6E6",
                                                            d: "M1.308 4.001H2.888V19.821H1.308z",
                                                            transform: "rotate(-7.07 2.098 11.91)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Path",
                                                            fill: "#F0F0F0",
                                                            d: "M0.02 1.11L0.31 4.36 1.99 4.15 1.48 0.93z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            id: "Rectangle",
                                                            fill: "#F0F0F0",
                                                            d: "M0.244 4.06H2.114V5.06H0.244z",
                                                            transform: "rotate(-7.07 1.18 4.51)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Rectangle",
                                                    fill: "#E0E0E0",
                                                    d: "M0.72 11.3H13.58V28.1H0.72z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Rectangle",
                                                    fill: "#EBEBEB",
                                                    d: "M3.02 11.3H13.57V28.1H3.02z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Path",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#E0E0E0",
                                                    d: "M.92.71h182.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z",
                                                    transform: "translate(11 175)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#E0E0E0",
                                                    d: "M.92.71h182.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z",
                                                    opacity: "0.2",
                                                    transform: "translate(11 175)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fill: "#EBEBEB",
                                                    d: "M.92.71h172.82v6.36c0 .7-.56 1.26-1.26 1.26H2.18c-.7 0-1.26-.56-1.26-1.26V.71z",
                                                    transform: "translate(11 175)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            transform: "translate(0 238)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#EBEBEB",
                                                    d: "M181.57 0.83L175.29 0.83 24.49 0.83 24.49 19.08 12.09 19.08 12.09 37.48 0.13 37.48 0.13 59.93 12.09 59.93 24.49 59.93 150.93 59.93 162.89 59.93 175.29 59.93 181.57 59.93 192.28 59.93 192.28 37.48 192.28 19.08 192.28 0.83z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Path",
                                                    fill: "#F5F5F5",
                                                    d: "M175.29 0.83L175.29 19.08 162.89 19.08 162.89 37.48 150.93 37.48 150.93 59.93 162.89 59.93 175.29 59.93 192.28 59.93 192.28 37.48 192.28 19.08 192.28 0.83z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Rectangle",
                                                    fill: "#E0E0E0",
                                                    d: "M24.49 12.16H175.29000000000002V19.07H24.49z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "Rectangle",
                                                    fill: "#E0E0E0",
                                                    d: "M12.09 30.38H162.89000000000001V37.48H12.09z"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Shadow",
                            fill: "#F5F5F5",
                            fillRule: "nonzero",
                            transform: "translate(56 350)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                id: "_Path_",
                                cx: "194",
                                cy: "12.24",
                                rx: "193.89",
                                ry: "11.32"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Plant",
                            fillRule: "nonzero",
                            transform: "translate(69 265)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                id: "Group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        id: "Path",
                                        fill: "#407BFF",
                                        d: "M18.24 73.56s4.75-10.36-.68-20.58c-5.43-10.22-7-12.62-3.54-14.72 3.46-2.1 5.05 8.17 5.05 8.17s2.92-7.06.51-14.45-3.92-19.43-.63-20.72c3.29-1.29.63 15.02 3.48 20.58 0 0 2.4-6.19 2.79-12.13.39-5.94-.22-15.42 2.38-17.85 2.6-2.43 4.26-.75 1.71 12.35s-2.53 23.75-2.53 23.75 5.64-17.19 9.42-17.69c3.78-.5 3.78 5.06.54 9.89-3.24 4.83-9.48 13.48-10.51 17.93 0 0 6.19-12.93 11.75-8.97 5.57 3.96-4.84 11.78-9.48 14.6-4.64 2.82-7.86 20.52-7.86 20.52l-2.39-.68h-.01z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        id: "Path",
                                        fill: "#000",
                                        d: "M18.24 73.56s4.75-10.36-.68-20.58c-5.43-10.22-7-12.62-3.54-14.72 3.46-2.1 5.05 8.17 5.05 8.17s2.92-7.06.51-14.45-3.92-19.43-.63-20.72c3.29-1.29.63 15.02 3.48 20.58 0 0 2.4-6.19 2.79-12.13.39-5.94-.22-15.42 2.38-17.85 2.6-2.43 4.26-.75 1.71 12.35s-2.53 23.75-2.53 23.75 5.64-17.19 9.42-17.69c3.78-.5 3.78 5.06.54 9.89-3.24 4.83-9.48 13.48-10.51 17.93 0 0 6.19-12.93 11.75-8.97 5.57 3.96-4.84 11.78-9.48 14.6-4.64 2.82-7.86 20.52-7.86 20.52l-2.39-.68h-.01z",
                                        opacity: "0.2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        id: "Path",
                                        fill: "#407BFF",
                                        d: "M21.99 77.81s-4.63-10.43.92-20.57 7.15-12.52 3.72-14.66c-3.43-2.14-5.14 8.1-5.14 8.1s-2.83-7.11-.33-14.46c2.5-7.36 4.15-19.37.88-20.71-3.27-1.34-.81 15.01-3.73 20.52 0 0-2.32-6.22-2.65-12.17-.33-5.95.41-15.41-2.16-17.88-2.57-2.47-4.25-.81-1.86 12.33 2.39 13.14 2.25 23.79 2.25 23.79S8.46 24.83 4.68 24.27c-3.78-.56-3.84 5.01-.66 9.88 3.18 4.88 9.32 13.62 10.29 18.08 0 0-6.03-13.02-11.64-9.14-5.61 3.88 4.7 11.85 9.31 14.74 4.61 2.89 7.62 20.63 7.62 20.63l2.4-.65h-.01z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        id: "Path",
                                        fill: "#263238",
                                        d: "M0.66 70.38L38.87 70.38 35.77 97.72 3.75 97.72z"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Height_meter",
                            fillRule: "nonzero",
                            transform: "translate(108 46)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                id: "Group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M42.99.26C19.62.26.68 19.2.68 42.57v252.14h84.63V42.58C85.31 19.21 66.37.27 43 .27l-.01-.01z",
                                                transform: "translate(30 22)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M42.99.26C19.62.26.68 19.2.68 42.57v252.14h84.63V42.58C85.31 19.21 66.37.27 43 .27l-.01-.01z",
                                                opacity: "0.7",
                                                transform: "translate(30 22)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M.06 25.85a5.898 5.898 0 017.59-5.65c-.09-.59-.13-1.2-.13-1.81 0-6.9 5.59-12.49 12.49-12.49.79 0 1.55.08 2.3.22C24.23 2.98 27.68.87 31.63.87c5.98 0 10.83 4.81 10.92 10.77h.18c5.56 0 10.06 4.51 10.06 10.06 0 5.55-4.51 10.06-10.06 10.06H5.78c-3.18-.1-5.73-2.7-5.73-5.9l.01-.01z",
                                                transform: "translate(75 42)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M.06 25.85a5.898 5.898 0 017.59-5.65c-.09-.59-.13-1.2-.13-1.81 0-6.9 5.59-12.49 12.49-12.49.79 0 1.55.08 2.3.22C24.23 2.98 27.68.87 31.63.87c5.98 0 10.83 4.81 10.92 10.77h.18c5.56 0 10.06 4.51 10.06 10.06 0 5.55-4.51 10.06-10.06 10.06H5.78c-3.18-.1-5.73-2.7-5.73-5.9l.01-.01z",
                                                opacity: "0.5",
                                                transform: "translate(75 42)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M.18 14.66c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0117.59.89c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H3.34a3.258 3.258 0 01-3.16-3.25v-.02z",
                                                transform: "translate(34 116)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M.18 14.66c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0117.59.89c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H3.34a3.258 3.258 0 01-3.16-3.25v-.02z",
                                                opacity: "0.5",
                                                transform: "translate(34 116)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M.18 19.3a4.426 4.426 0 015.7-4.24c-.06-.44-.1-.9-.1-1.36a9.38 9.38 0 0111.11-9.22 8.187 8.187 0 017-3.94c4.49 0 8.13 3.61 8.2 8.08h.14a7.56 7.56 0 017.56 7.56c0 4.18-3.38 7.56-7.56 7.56H4.49a4.432 4.432 0 01-4.3-4.43l-.01-.01z",
                                                transform: "translate(43 9)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M.18 19.3a4.426 4.426 0 015.7-4.24c-.06-.44-.1-.9-.1-1.36a9.38 9.38 0 0111.11-9.22 8.187 8.187 0 017-3.94c4.49 0 8.13 3.61 8.2 8.08h.14a7.56 7.56 0 017.56 7.56c0 4.18-3.38 7.56-7.56 7.56H4.49a4.432 4.432 0 01-4.3-4.43l-.01-.01z",
                                                opacity: "0.5",
                                                transform: "translate(43 9)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M.9 14.5c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0118.31.73c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H4.06A3.258 3.258 0 01.9 14.52v-.02z",
                                                transform: "translate(8 164)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M.9 14.5c0-1.8 1.46-3.25 3.25-3.25.33 0 .64.05.93.14-.05-.33-.07-.66-.07-1a6.89 6.89 0 018.16-6.77A6.02 6.02 0 0118.31.73c3.3 0 5.98 2.65 6.03 5.94h.1a5.55 5.55 0 015.55 5.55c0 3.06-2.49 5.55-5.55 5.55H4.06A3.258 3.258 0 01.9 14.52v-.02z",
                                                opacity: "0.5",
                                                transform: "translate(8 164)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#407BFF",
                                                d: "M.16 22.7a5.185 5.185 0 016.68-4.97c-.08-.52-.12-1.05-.12-1.59 0-6.07 4.92-10.99 10.99-10.99.69 0 1.37.07 2.03.19C21.43 2.57 24.47.72 27.95.72c5.26 0 9.53 4.23 9.61 9.48h.16c4.89 0 8.86 3.97 8.86 8.86 0 4.89-3.97 8.86-8.86 8.86H5.2C2.4 27.83.15 25.55.15 22.73l.01-.03z",
                                                transform: "translate(0 44)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M.16 22.7a5.185 5.185 0 016.68-4.97c-.08-.52-.12-1.05-.12-1.59 0-6.07 4.92-10.99 10.99-10.99.69 0 1.37.07 2.03.19C21.43 2.57 24.47.72 27.95.72c5.26 0 9.53 4.23 9.61 9.48h.16c4.89 0 8.86 3.97 8.86 8.86 0 4.89-3.97 8.86-8.86 8.86H5.2C2.4 27.83.15 25.55.15 22.73l.01-.03z",
                                                opacity: "0.5",
                                                transform: "translate(0 44)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "rocket",
                                        transform: "translate(8)",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "Group",
                                                transform: "translate(9 102)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#263238",
                                                        d: "M30.99 0.98L40.72 214.72 0.96 214.72 11.32 0.98z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#FAFAFA",
                                                        d: "M30.99 0.98L40.72 214.72 0.96 214.72 11.32 0.98z",
                                                        opacity: "0.8"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#FAFAFA",
                                                        d: "M6.37 214.29L13.5 80.56 15.5 114.36 21.16 21.5 28.32 104.51 28.32 46.94 35.3 214.72z",
                                                        opacity: "0.3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "Group",
                                                transform: "translate(15 84)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#407BFF",
                                                        d: "M21.71.08s7.71 9.76 7.52 17.07c-.19 7.31-2.97 9.57-2.97 9.57l.4-4.74s-1.64 8.76-8.93 14.03l-2.64-4.82s-.89 5.34 0 8.31c0 0-9.33-5.39-10.15-12.78l-1.03 3.11S-.24 22.88.55 16.16C1.34 9.44 7.68.93 7.68.93L21.72.07l-.01.01z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#FAFAFA",
                                                        d: "M21.71.08s7.71 9.76 7.52 17.07c-.19 7.31-2.97 9.57-2.97 9.57l.4-4.74s-1.64 8.76-8.93 14.03l-2.64-4.82s-.89 5.34 0 8.31c0 0-9.33-5.39-10.15-12.78l-1.03 3.11S-.24 22.88.55 16.16C1.34 9.44 7.68.93 7.68.93L21.72.07l-.01.01z",
                                                        opacity: "0.2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#FAFAFA",
                                                        d: "M22.44 4.3s2.54 5.14 3.18 9.49c.64 4.35-1.59 7.29-1.59 7.29l.06-5.18s-.7 5.98-4.68 10.95l-3.69-5.77s-2.77 4.84-2.64 8.01c0 0-4.68-4.09-3.46-10.55 0 0-1.82 1.85-1.95 3.3 0 0-6.46-5.54 0-17.54h14.77z",
                                                        opacity: "0.2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "Group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#407BFF",
                                                        d: "M19.5 81.18h20.69v4.51c0 .71-.58 1.29-1.29 1.29H20.8c-.71 0-1.29-.58-1.29-1.29v-4.51h-.01z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#FAFAFA",
                                                        d: "M19.5 81.18h20.69v4.51c0 .71-.58 1.29-1.29 1.29H20.8c-.71 0-1.29-.58-1.29-1.29v-4.51h-.01z",
                                                        opacity: "0.5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#407BFF",
                                                        d: "M40.37 81.18H19.31s-7.39-39.56-4.22-56.01c1.3-6.74 4.39-12.48 7.6-16.9 1.66-2.3 3.36-4.24 4.84-5.79.49-.51.96-.97 1.39-1.39.51-.49 1.32-.49 1.83 0 .43.42.9.88 1.38 1.39 1.48 1.55 3.18 3.49 4.84 5.79 3.21 4.42 6.31 10.16 7.61 16.9 3.16 16.45-4.22 56.01-4.22 56.01h.01z"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        id: "Oval",
                                                        cx: "29.84",
                                                        cy: "34.36",
                                                        r: "10.15",
                                                        fill: "#FAFAFA",
                                                        opacity: "0.6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        id: "Oval",
                                                        cx: "29.84",
                                                        cy: "34.36",
                                                        r: "7.41",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        id: "Path",
                                                        fill: "#263238",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M43.14.42S55.4 3.73 58.17 12.63c1.93 6.19.31 13.99-.85 18.16-.27.96-1.58 1.04-1.98.13-1.87-4.33-6.43-12.17-14.98-12.75 0 0 0-2.58.7-8.61.74-6.42 2.08-9.15 2.08-9.15v.01zM16.53.42S4.27 3.73 1.5 12.63c-1.93 6.19-.31 13.99.85 18.16.27.96 1.58 1.04 1.98.13 1.87-4.33 6.43-12.17 14.98-12.75 0 0 0-2.58-.7-8.61-.74-6.42-2.08-9.15-2.08-9.15v.01z",
                                                            transform: "translate(0 63)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        id: "Path",
                                                        fill: "#263238",
                                                        d: "M29.84 63.42c1.46 0 2.64 1.18 2.64 2.64v26.16c0 1.29-1.05 2.34-2.34 2.34h-.59c-1.29 0-2.34-1.05-2.34-2.34V66.06c0-1.46 1.18-2.64 2.64-2.64h-.01zM36.98 8.27H22.69c1.66-2.3 3.36-4.24 4.84-5.79.49-.51.96-.97 1.39-1.39.51-.49 1.32-.49 1.83 0 .43.42.9.88 1.38 1.39 1.48 1.55 3.18 3.49 4.84 5.79h.01z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Path",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#263238",
                                                d: "M1.58 16.72c-2.85-4.69 1.88-8.52 4.5-5.9 0 0-3.18-5.97 3.94-9.33 7.12-3.36 10.81 2.36 10.81 5.04 0 0 1.58-6.43 9.49-5.04 7.91 1.39 7.61 10.27 7.61 10.27s2.66-6.67 11.12-4.2c0 0-.53-7.15 5.8-7.1 6.33.04 7.12 4.79 7.12 4.79s2.37-3.08 6.33.57 1.29 6.71 1.29 6.71 5.72-.7 5.38 4.18H1.58v.01z",
                                                transform: "translate(0 300)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M1.58 16.72c-2.85-4.69 1.88-8.52 4.5-5.9 0 0-3.18-5.97 3.94-9.33 7.12-3.36 10.81 2.36 10.81 5.04 0 0 1.58-6.43 9.49-5.04 7.91 1.39 7.61 10.27 7.61 10.27s2.66-6.67 11.12-4.2c0 0-.53-7.15 5.8-7.1 6.33.04 7.12 4.79 7.12 4.79s2.37-3.08 6.33.57 1.29 6.71 1.29 6.71 5.72-.7 5.38 4.18H1.58v.01z",
                                                opacity: "0.6",
                                                transform: "translate(0 300)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "#FAFAFA",
                                                d: "M10.61 16.72s-2.18-3.99 2.18-7.12c4.35-3.13 9.1 1.28 9.1 1.28s.79-4.33 5.74-3.38c4.94.95 4.91 6.35 4.91 6.35s5.17-2.8 9.53 1.24c0 0 .59-3.85 4.15-4.85 3.56-1 6.18 2.42 6.18 2.42s-.07-4.87 4.98-5.53c5.06-.66 6.64 4.66 5.85 6.15 0 0 3.36.23 3.36 3.43H10.61v.01z",
                                                opacity: "0.4",
                                                transform: "translate(0 300)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        id: "Rectangle",
                                        fill: "#000",
                                        opacity: "0.2",
                                        transform: "translate(86 80)",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 0.18H28.77V2.18H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 6.16H28.77V8.16H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 12.13H28.77V14.13H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 18.11H28.77V20.11H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 24.09H28.77V26.09H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 30.06H28.77V32.06H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 36.04H28.77V38.04H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 42.02H28.77V44.02H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 47.99H28.77V49.99H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 53.97H28.77V55.97H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 59.95H28.77V61.95H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 65.92H28.77V67.92H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 71.9H28.77V73.9H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 77.88H28.77V79.88H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 83.85H28.77V85.85H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 89.83H28.77V91.83H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 95.81H28.77V97.81H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 101.78H28.77V103.78H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 107.76H28.77V109.76H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 113.74H28.77V115.74H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 119.71H28.77V121.71H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 125.69H28.77V127.69H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 131.67H28.77V133.67H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 137.64H28.77V139.64H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 143.62H28.77V145.62H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 149.6H28.77V151.6H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 155.57H28.77V157.57H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 161.55H28.77V163.55H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 167.53H28.77V169.53H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 173.5H28.77V175.5H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 179.48H28.77V181.48H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 185.46H28.77V187.46H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 191.43H28.77V193.43H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 197.41H28.77V199.41H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 203.39H28.77V205.39H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 209.36H28.77V211.36H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0.49 215.34H28.77V217.34H0.49z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 221.32H28.77V223.32H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 227.29H28.77V229.29H14.5z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.5 233.27H28.77V235.27H14.5z"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Rectangle",
                            fill: "#FFF",
                            d: "M56 362H243V374H56z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Shadow",
                            fill: "#F5F5F5",
                            fillRule: "nonzero",
                            transform: "translate(56 362)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "Combined-Shape",
                                d: "M387.848 0a.71.71 0 01.042.24c0 6.252-86.808 11.32-193.89 11.32C86.918 11.56.11 6.492.11.24.11.16.124.08.152 0z"
                            })
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utilities/bookStack.ts
var bookStack = __webpack_require__(70545);
;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageHeight.tsx













var HomepageHeight_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        grid: {
            display: "grid",
            gridTemplateColumns: "1fr",
            overflow: "hidden",
            "> *": {
                gridColumn: "1 / 2",
                gridRow: "1 / 2"
            },
            "> svg": (0,_define_property/* default */.Z)({
                maxWidth: "100%",
                height: "auto",
                transform: "translateX(-12%)"
            }, theme.fn.largerThan("sm"), {
                transform: "none"
            })
        },
        readPagesWrapper: {
            zIndex: 1
        },
        readPages: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 900,
            fontSize: 35
        }, theme.fn.largerThan("sm"), {
            fontSize: 65
        }),
        readPagesSubtext: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 700,
            fontSize: 20
        }, theme.fn.largerThan("sm"), {
            fontSize: 35
        }),
        readPagesCurrent: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 900,
            fontSize: 25
        }, theme.fn.largerThan("sm"), {
            fontSize: 45
        }),
        readPagesCurrentSubtext: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 700,
            fontSize: 16
        }, theme.fn.largerThan("sm"), {
            fontSize: 24
        })
    };
});
var formatter = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
var HomepageHeight = function(_param) {
    var readPages = _param.readPages, readPagesCurrentYear = _param.readPagesCurrentYear, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "readPages",
        "readPagesCurrentYear"
    ]);
    var additionalText = readPagesCurrentYear && readPagesCurrentYear >= 250000;
    var classes = HomepageHeight_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    var stackHeight = (0,bookStack/* getStackHeightInMM */.V)(readPages) / 1000;
    var stackHeightCurrent = (0,bookStack/* getStackHeightInMM */.V)(readPagesCurrentYear || 0) / 1000;
    (0,react.useEffect)(function() {
        if (false) {}
        gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
        var t = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                trigger: "#stackHeight",
                start: "top center",
                end: "bottom center"
            }
        });
        t.from("#rocket", {
            yPercent: 70,
            duration: 2,
            ease: "power2.in"
        }).from("#stackHeight-text", {
            xPercent: 100,
            duration: 0.3
        }, 0).fromTo("#stackHeightValue", {
            textContent: "0.00"
        }, {
            textContent: stackHeight.toFixed(2).toString(),
            ease: "power3.out",
            // ease: 'none',
            duration: 2,
            snap: {
                textContent: 0.01
            },
            onUpdate: function onUpdate() {
                var targets = this.targets();
                if (targets && targets[0]) {
                    targets[0].innerHTML = formatter.format(this.targets()[0].textContent);
                }
            }
        }, 0).fromTo("#stackHeightCurrentValue", {
            textContent: "0.00"
        }, {
            textContent: stackHeightCurrent.toFixed(2).toString(),
            ease: "power3.out",
            // ease: 'none',
            duration: 2,
            snap: {
                textContent: 0.01
            },
            onUpdate: function onUpdate() {
                var targets = this.targets();
                if (targets && targets[0]) {
                    targets[0].innerHTML = formatter.format(this.targets()[0].textContent);
                }
            }
        }, "<+=0.5");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: "stackHeight",
        className: classes.grid
    }, boxProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                id: "stackHeight-text",
                spacing: 0,
                className: classes.readPagesWrapper,
                justify: "center",
                align: "end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.readPages,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                            ns: "page_homepage",
                            i18nKey: "stats.stackHeight.unit",
                            values: {
                                height: stackHeight.toFixed(2).toString()
                            },
                            components: {
                                number: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    id: "stackHeightValue"
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        className: classes.readPagesSubtext,
                        children: t("stats.stackHeight.description")
                    }),
                    additionalText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                mt: 20,
                                className: classes.readPagesCurrent,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                                    ns: "page_homepage",
                                    i18nKey: "stats.stackHeight.unit",
                                    values: {
                                        height: stackHeightCurrent.toFixed(2).toString()
                                    },
                                    components: {
                                        number: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            id: "stackHeightCurrentValue"
                                        })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                className: classes.readPagesCurrentSubtext,
                                children: t("stats.stackHeight.currentYear")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StackHeightSvg, {})
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/BookSvg.tsx


var BooksSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "316",
        height: "241",
        viewBox: "0 0 316 241",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Page-1",
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "10.2”-iPad",
                fillRule: "nonzero",
                transform: "translate(-33 -91)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "books",
                    transform: "translate(33 91)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Group",
                            fill: "#15927C",
                            opacity: "0.33",
                            transform: "translate(55 7)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "Path",
                                d: "M131.166 217.908c-21.758-6.924-45.283-4.713-67.83-8.306-18.535-2.947-37.055-10.316-49.614-24.31C1.17 171.3-4.071 149.806 4.332 132.98c7.232-14.485 23.632-25.2 23.831-41.405.084-6.624-2.717-12.895-4.423-19.297-5.832-21.831 2.066-46.724 19.393-61.17C54.046 2.01 69.68-2.91 82.683 2.777c8.212 3.593 14.365 10.87 22.508 14.616 10.255 4.713 22.11 3.232 33.383 3.769 11.64.56 23.472 3.554 32.793 10.57 9.322 7.023 15.735 18.514 14.732 30.167-.428 4.928-1.99 10.408.827 14.47 1.232 1.772 3.115 2.939 4.913 4.129 12.008 7.93 22.255 18.898 27.972 32.124 5.717 13.226 6.612 28.785 1.056 42.08-3.81 9.127-10.393 16.826-17.586 23.589-16.133 15.175-35.909 26.428-57.169 32.539"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    id: "Oval",
                                    cx: "162.554",
                                    cy: "227.047",
                                    fill: "#15927C",
                                    opacity: "0.33",
                                    rx: "119.877",
                                    ry: "13.616"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    fill: "#0B5B50",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M48.96 24.967a208.648 208.648 0 01-17.333 18.92A207.187 207.187 0 01.414 68.708c-.759.491-.054 1.712.713 1.22A210.319 210.319 0 0040.485 36.88a210.308 210.308 0 009.472-10.914c.238-.292.291-.706 0-.998-.245-.245-.75-.299-.996 0z",
                                            transform: "translate(226.834 125.105)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M47.628 27.677c1.586-5.204 3.31-10.416 6.023-15.136 2.713-4.72 6.483-8.964 11.342-11.405C66.333.46 67.79-.077 69.284.016c1.494.091 3.02.959 3.518 2.371.275.775.222 1.627.076 2.44-.544 3.055-2.337 5.734-4.268 8.152-5.395 6.746-13.243 10.906-20.99 14.705M16.193 58.055c-1.135-5.327-2.146-10.722-2.062-16.164.084-5.442 1.334-10.99 4.391-15.488.843-1.236 1.862-2.426 3.211-3.063 1.349-.637 3.104-.63 4.223.36.613.546.988 1.313 1.249 2.096 1.004 2.932.735 6.148.214 9.203-1.448 8.52-6.299 15.972-11.226 23.056M35.91 40.479c-.965-3.385-1.862-6.823-2.038-10.362-.176-3.538.414-7.207 2.245-10.307.506-.852 1.127-1.681 1.985-2.18.866-.499 2.015-.599 2.797-.023.43.314.705.79.912 1.282.782 1.842.743 3.945.529 5.955-.598 5.611-3.48 10.738-6.422 15.635M39.573 36.856c5.15-3.922 14.73-10.56 21.044-11.965 3.425-.768 7.418-.99 10.054 1.327.751.668 1.372 1.59 1.326 2.595-.054 1.128-.904 2.049-1.77 2.77-3.932 3.308-9.043 4.905-14.124 5.634-5.48.79-11.089.668-16.53-.369M10.828 62.652c6.292-1.512 17.726-3.707 24.07-2.448 3.45.683 7.189 2.088 8.668 5.28.421.914.613 2.011.169 2.917-.499 1.013-1.656 1.504-2.736 1.819-4.935 1.435-10.254.829-15.197-.553a50.16 50.16 0 01-14.974-7.015M28.147 48.238c5.311-2.18 15.036-5.656 20.768-5.41 3.111.13 6.583.851 8.307 3.453.49.745.812 1.681.544 2.533-.299.96-1.241 1.543-2.153 1.965-4.13 1.926-8.874 2.118-13.396 1.58a44.656 44.656 0 01-14.07-4.113",
                                            transform: "translate(226.834 125.105)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    fill: "#0B5B50",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M22.982 20.14a173.91 173.91 0 0133.535 26.164c2.835 2.84 5.579 5.78 8.215 8.811.49.568 1.418-.16.92-.729a176.124 176.124 0 00-15.105-15.35 174.73 174.73 0 00-16.752-13.294 177.517 177.517 0 00-10.108-6.546c-.268-.162-.62-.154-.82.115-.176.23-.153.66.115.82v.009z",
                                            transform: "translate(13.794 118.965)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M25.366 20.922c-4.476-.698-8.974-1.512-13.181-3.192C7.978 16.049 4.039 13.424 1.448 9.7.736 8.673.115 7.53.023 6.286c-.092-1.243.43-2.61 1.54-3.185.606-.323 1.318-.376 2-.353 2.583.092 4.997 1.25 7.22 2.57 6.191 3.662 10.544 9.664 14.59 15.612M54.095 43.326c-4.253 1.566-8.583 3.04-13.073 3.608-4.491.575-9.212.191-13.273-1.812-1.119-.552-2.215-1.25-2.905-2.295-.69-1.043-.88-2.486-.199-3.53.376-.576.966-.967 1.579-1.282 2.299-1.174 4.973-1.328 7.556-1.259 7.188.2 13.901 3.324 20.323 6.57M37.297 29.104c-2.674 1.198-5.402 2.341-8.299 2.901-2.89.56-5.985.507-8.76-.637-.766-.314-1.517-.729-2.03-1.381-.513-.653-.728-1.597-.345-2.31.207-.392.575-.676.95-.906 1.426-.867 3.158-1.075 4.844-1.136 4.697-.169 9.257 1.612 13.64 3.47M33.88 26.495c-3.84-3.792-10.43-10.93-12.338-15.98-1.035-2.748-1.694-6.01-.085-8.466.46-.698 1.15-1.32 1.985-1.404.935-.092 1.793.506 2.49 1.136 3.189 2.862 5.104 6.9 6.308 11.013a42.037 42.037 0 011.64 13.7M58.51 47.218c-1.985-5.02-5.143-14.215-4.851-19.61.16-2.932.873-6.187 3.333-7.783.705-.46 1.586-.745 2.383-.484.897.292 1.433 1.19 1.824 2.05 1.763 3.906 1.893 8.373 1.334 12.625a41.97 41.97 0 01-4.016 13.202M44.6 34.6c-2.421-4.13-6.429-11.759-6.904-16.525-.26-2.587-.07-5.541 1.862-7.276.552-.499 1.287-.867 2.023-.745.82.139 1.418.845 1.878 1.55 2.069 3.186 2.79 7.085 2.873 10.884A37.26 37.26 0 0144.601 34.6",
                                            transform: "translate(13.794 118.965)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#005E50",
                                    d: "M242.153 89.462c2.253-5.926 5.257-11.56 8.867-16.755A78.796 78.796 0 01263.64 58.56a76.569 76.569 0 018.499-6.493c.628-.414.038-1.435-.59-1.013a78.967 78.967 0 00-14.737 12.564 80.341 80.341 0 00-11.227 15.65 79.115 79.115 0 00-4.56 9.893c-.114.3.123.645.407.722.33.092.605-.115.72-.407v-.015z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#005E50",
                                    d: "M246.391 80.413a53.082 53.082 0 0116.177-9.141 53.038 53.038 0 015.058-1.497c.736-.177.421-1.313-.314-1.136a54.294 54.294 0 00-17.404 7.69 56.2 56.2 0 00-4.345 3.255c-.582.483.253 1.312.828.829z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#13937E",
                                    d: "M263.411 58.285c-.881-7.414 2.192-15.189 7.901-19.994 3.165-2.663 7.02-4.42 11.012-5.457 2.583-.675 5.234-1.059 7.878-1.443 2.291-.33 4.575-.667 6.866-.997.215-.031.46-.054.621.092.192.176.153.483.092.737-.421 1.85-.85 3.699-1.38 5.518-1.938 6.67-5.44 13.094-10.965 17.307-6.008 4.583-14.76 6.317-22.025 4.245"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#0B5B50",
                                    d: "M261.311 70.957c2.69-5.51 8.254-9.502 14.33-10.277 3.365-.43 6.806.077 10.024 1.136 2.085.683 4.085 1.596 6.077 2.51 1.725.79 3.457 1.58 5.18 2.363.162.077.346.17.392.346.053.207-.115.399-.269.552-1.11 1.09-2.23 2.173-3.402 3.193-4.3 3.738-9.572 6.609-15.242 7.054-6.185.483-12.99-2.218-17.082-6.877"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#005E50",
                                    d: "M83.477 173.896c-2.744 5.71-6.208 11.068-10.246 15.95a78.847 78.847 0 01-13.764 13.031 76.76 76.76 0 01-9.02 5.757c-.658.36-.16 1.42.506 1.059a78.978 78.978 0 0015.74-11.275A80.585 80.585 0 0079.2 183.774a79.467 79.467 0 005.38-9.471c.138-.284-.069-.653-.345-.752-.322-.115-.613.061-.75.345h-.008z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#005E50",
                                    d: "M78.495 182.561a52.9 52.9 0 01-22.047 8.811c-.743.116-.529 1.274.215 1.16a54.31 54.31 0 0017.993-6.194 54.858 54.858 0 004.598-2.879c.62-.43-.138-1.327-.759-.898z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#0B5B50",
                                    d: "M57.896 204.22c.253 7.469-3.463 14.952-9.556 19.258-3.372 2.387-7.364 3.806-11.433 4.513-2.629.452-5.303.614-7.97.775l-6.928.414c-.215.016-.467.016-.613-.146-.176-.191-.107-.498-.03-.744.574-1.804 1.156-3.615 1.839-5.38 2.498-6.486 6.529-12.588 12.376-16.318 6.376-4.06 15.242-5.05 22.308-2.371"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#13937E",
                                    d: "M62.832 190.728c-3.142 5.265-9.028 8.772-15.143 9.033-3.387.146-6.775-.652-9.894-1.98-2.015-.86-3.93-1.934-5.839-3.016-1.655-.929-3.31-1.865-4.966-2.794-.153-.084-.33-.2-.36-.376-.038-.215.146-.391.314-.53 1.203-.99 2.407-1.98 3.656-2.893 4.598-3.362 10.092-5.78 15.786-5.749 6.2.039 12.752 3.3 16.446 8.297"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#2D0E03",
                                            d: "M31.35 9.103c-.352-.008-.72.291-.704.667.26 6.263.674 12.534 1.64 18.736.904 5.787 2.314 11.505 4.49 16.954a57.499 57.499 0 002.66 5.703 105.933 105.933 0 01-6.147-5.442.677.677 0 00-.168-.161c-.337-.33-.69-.645-1.027-.983-3.387-3.37-6.53-7.007-9.219-10.96-.238-.345-.46-.69-.69-1.036a72.101 72.101 0 00-.705-18.39 67.247 67.247 0 00-1.042-5.058c-.207-.86-1.54-.544-1.333.315a70.572 70.572 0 011.984 18.06 71.305 71.305 0 01-.137 3.131c-2.039-3.354-3.794-6.869-5.372-10.469-2.047-4.666-3.817-9.463-4.974-14.429a48.75 48.75 0 01-.398-1.834c-.177-.868-1.51-.553-1.334.314 1.02 5.081 2.713 9.993 4.713 14.767 2 4.774 4.292 9.448 7.096 13.808 2.644 4.106 5.732 7.92 9.12 11.428.06.062.115.123.176.177a56.374 56.374 0 01-9.22-4.644A56.126 56.126 0 0110.285 31.3a55.12 55.12 0 01-4.935-5.833c-.222-.3-.72-.268-.966-.038-.298.276-.26.668-.038.967 2.728 3.715 5.916 7.061 9.457 10.008a57.112 57.112 0 0018.484 10.293c2.682 2.57 5.51 4.989 8.43 7.283 3.854 3.032 7.862 5.849 11.939 8.558.49.33.988.653 1.479.975.735.483 1.471-.675.735-1.159-4.054-2.656-8.046-5.403-11.893-8.35-.23-.177-.46-.361-.69-.546 0-.015 0-.03-.015-.038-2.085-3.37-3.755-6.977-5.089-10.7.023-.045.054-.076.07-.137a38.211 38.211 0 001.501-13.163c-.023-.369-.275-.69-.666-.706-.345-.008-.728.291-.705.668a37.5 37.5 0 01-.981 11.052 74.234 74.234 0 01-.759-2.54c-1.594-5.757-2.483-11.69-3.012-17.638-.306-3.47-.498-6.954-.643-10.43-.016-.37-.276-.692-.667-.707l.03-.015z",
                                            transform: "translate(41.382 49.121)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#FF5E1E",
                                            d: "M5.012 21.437a3.61 3.61 0 012.39 4.513 3.602 3.602 0 01-4.505 2.394 3.61 3.61 0 01-2.391-4.513 3.602 3.602 0 014.506-2.394zM10.024.223a3.61 3.61 0 012.39 4.513A3.602 3.602 0 017.91 7.13a3.61 3.61 0 01-2.391-4.513A3.602 3.602 0 0110.024.223zM20.576 5.188a3.61 3.61 0 012.391 4.513 3.602 3.602 0 01-4.506 2.395 3.61 3.61 0 01-2.391-4.513 3.602 3.602 0 014.506-2.395zM32.47 17.937a3.61 3.61 0 012.39 4.513 3.602 3.602 0 01-4.506 2.394 3.61 3.61 0 01-2.39-4.513 3.602 3.602 0 014.505-2.394zM16.491 34.776a3.61 3.61 0 012.391 4.513 3.602 3.602 0 01-4.506 2.395 3.61 3.61 0 01-2.39-4.513 3.602 3.602 0 014.505-2.395zM39.941 25.673a3.61 3.61 0 012.391 4.513 3.602 3.602 0 01-4.506 2.395 3.61 3.61 0 01-2.39-4.513 3.602 3.602 0 014.505-2.395zM31.726 5.419a3.61 3.61 0 012.391 4.513 3.602 3.602 0 01-4.506 2.394 3.61 3.61 0 01-2.39-4.513 3.602 3.602 0 014.505-2.394z",
                                            transform: "translate(41.382 49.121)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#2D0E03",
                                            d: "M38.125 22.058c-.008-.253-.245-.498-.513-.468-4.445.507-8.882 1.12-13.243 2.126-4.069.937-8.061 2.241-11.824 4.068a40.875 40.875 0 00-3.924 2.187 77.78 77.78 0 013.556-4.658.465.465 0 00.107-.13c.215-.262.422-.523.644-.784 2.222-2.586 4.652-5.012 7.326-7.138.23-.184.468-.36.705-.545a51.132 51.132 0 0013.043-1.442 51.769 51.769 0 003.548-.998c.598-.192.307-1.128-.291-.937a49.982 49.982 0 01-12.744 2.341c-.743.039-1.494.054-2.238.062 2.284-1.627 4.698-3.063 7.165-4.367 3.211-1.697 6.537-3.209 10.009-4.283.429-.13.85-.261 1.287-.376.606-.17.314-1.105-.291-.937-3.563.99-6.966 2.449-10.261 4.114-3.295 1.673-6.499 3.546-9.457 5.764-2.79 2.096-5.341 4.49-7.663 7.092-.038.046-.077.092-.123.138a39.23 39.23 0 012.836-6.815 40.093 40.093 0 015.479-7.906 39.9 39.9 0 013.9-3.822c.2-.169.154-.522-.022-.69-.207-.2-.49-.154-.69.022a40.59 40.59 0 00-6.636 7.261 40.565 40.565 0 00-4.698 8.58 41.386 41.386 0 00-1.67 5.136c-1.694 2.041-3.265 4.19-4.752 6.385-1.954 2.902-3.755 5.91-5.48 8.957L.59 41.1c-.306.553.552 1.014.858.469 1.686-3.024 3.434-6.018 5.326-8.911.115-.177.238-.346.353-.522.008 0 .023 0 .03-.015 2.292-1.658 4.767-3.04 7.35-4.176.03.016.061.039.1.046 3.095.676 6.299.822 9.44.4.261-.039.483-.23.468-.515-.008-.245-.245-.506-.513-.468a26.523 26.523 0 01-7.909-.13c.582-.23 1.172-.461 1.77-.676 4.016-1.427 8.192-2.372 12.392-3.047 2.452-.399 4.92-.714 7.387-.99.26-.03.483-.23.468-.514l.015.007z",
                                            transform: "translate(233.731 99.777)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#FF5E1E",
                                            d: "M28.01 3.891a2.574 2.574 0 01-3.089 1.934 2.578 2.578 0 01-1.931-3.093A2.574 2.574 0 0126.078.798a2.578 2.578 0 011.931 3.093zM43.351 6.378a2.57 2.57 0 01-3.088 1.934 2.578 2.578 0 01-1.931-3.093 2.574 2.574 0 013.088-1.934 2.578 2.578 0 011.931 3.093zM40.363 14.168a2.574 2.574 0 01-3.089 1.934 2.578 2.578 0 01-1.93-3.093 2.57 2.57 0 013.088-1.934 2.578 2.578 0 011.93 3.093zM31.902 23.302a2.574 2.574 0 01-3.088 1.934 2.578 2.578 0 01-1.931-3.093 2.574 2.574 0 013.088-1.934 2.578 2.578 0 011.931 3.093zM19.112 12.764a2.574 2.574 0 01-3.088 1.934 2.578 2.578 0 01-1.931-3.093A2.574 2.574 0 0117.18 9.67a2.578 2.578 0 011.931 3.093zM26.783 29.027a2.574 2.574 0 01-3.088 1.935 2.578 2.578 0 01-1.931-3.093 2.574 2.574 0 013.088-1.935 2.578 2.578 0 011.931 3.093zM40.769 22.127a2.574 2.574 0 01-3.088 1.935 2.578 2.578 0 01-1.932-3.093 2.574 2.574 0 013.089-1.935 2.578 2.578 0 011.93 3.093z",
                                            transform: "translate(233.731 99.777)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    fill: "#FF5E1E",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M4.736 4.805c.16-.944.536-1.85 1.088-2.633.284-.407.629-.783 1.065-1.02.238-.131.498-.223.767-.208.268.015.536.138.682.36.23.354.1.822-.108 1.183-.352.606-.92 1.067-1.517 1.443-.598.376-1.241.675-1.84 1.044",
                                            transform: "translate(31.42 93.637)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M4.859 4.728a6.426 6.426 0 012.674-.967c.49-.062 1.004-.062 1.471.1.253.084.499.222.667.43.169.207.26.49.192.752-.108.406-.537.629-.95.713-.69.146-1.41.039-2.085-.153-.674-.192-1.333-.468-2.008-.66M5.042 4.605a6.307 6.307 0 01-2.72.844c-.49.039-1.004.016-1.464-.16-.253-.1-.49-.246-.651-.461-.161-.215-.238-.5-.161-.76.123-.4.567-.607.98-.676.698-.115 1.41.023 2.078.246.666.223 1.31.522 1.977.745",
                                            transform: "translate(31.42 93.637)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M5.027 4.966a6.396 6.396 0 01-1.923-2.103c-.246-.43-.437-.906-.475-1.397-.016-.269.015-.545.137-.783.123-.238.353-.43.614-.468.413-.061.789.253 1.026.599.399.583.575 1.289.66 1.987.084.699.084 1.413.168 2.111M5.111 5.104c.445.852.69 1.804.713 2.755.015.5-.03 1.006-.237 1.459a1.512 1.512 0 01-.483.629c-.222.154-.514.215-.767.123-.39-.146-.574-.599-.628-1.013-.084-.699.092-1.405.345-2.065.253-.66.582-1.282.843-1.942M4.759 4.95a6.494 6.494 0 01-1.38 2.495c-.329.368-.712.706-1.172.898-.245.1-.521.161-.782.123-.268-.046-.52-.2-.636-.438-.184-.376-.007-.829.246-1.166.421-.56 1.034-.96 1.67-1.26.636-.298 1.31-.529 1.947-.828",
                                            transform: "translate(31.42 93.637)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M5.18 5.035a6.45 6.45 0 012.637 1.067c.406.284.789.621 1.026 1.059.13.23.223.499.215.767a.87.87 0 01-.352.691c-.345.23-.82.108-1.18-.1-.614-.353-1.073-.913-1.457-1.504-.375-.599-.682-1.236-1.057-1.834",
                                            transform: "translate(31.42 93.637)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    fill: "#000601",
                                    d: "M36.34 100.13c1.57 0 1.57-2.44 0-2.44-1.572 0-1.572 2.44 0 2.44z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#FFF",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M13.464 13.263a18.15 18.15 0 013.096-7.484c.82-1.15 1.794-2.218 3.02-2.908.666-.369 1.417-.622 2.176-.591.759.03 1.533.391 1.947 1.028.651.998.29 2.34-.307 3.37-1.011 1.726-2.62 3.039-4.314 4.098-1.694 1.06-3.525 1.911-5.227 2.97",
                                                    transform: "translate(0 152.736)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M13.81 13.048a18.207 18.207 0 017.609-2.748c1.395-.169 2.843-.169 4.184.284.72.246 1.418.63 1.9 1.213.491.583.744 1.397.552 2.133-.298 1.152-1.532 1.789-2.697 2.034-1.962.415-4.008.108-5.931-.437-1.924-.545-3.786-1.32-5.71-1.873M14.338 12.702a18.201 18.201 0 01-7.725 2.403c-1.402.107-2.85.038-4.16-.468-.713-.277-1.388-.691-1.848-1.298-.46-.606-.682-1.427-.452-2.156.353-1.136 1.61-1.72 2.782-1.911 1.977-.323 4.008.076 5.908.706 1.901.63 3.717 1.489 5.618 2.126",
                                                    transform: "translate(0 152.736)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M14.3 13.739a18.213 18.213 0 01-5.464-5.98c-.698-1.227-1.25-2.563-1.349-3.975-.054-.76.03-1.55.383-2.226C8.223.883 8.866.338 9.625.23c1.173-.169 2.245.73 2.912 1.704 1.134 1.65 1.64 3.661 1.878 5.65.237 1.987.237 4.005.475 5.993M14.537 14.13a18.06 18.06 0 012.023 7.844c.039 1.412-.092 2.855-.666 4.145-.307.698-.759 1.35-1.387 1.78-.629.43-1.456.614-2.17.353-1.118-.407-1.639-1.696-1.777-2.878-.23-1.995.268-4.006.989-5.871.72-1.873 1.663-3.654 2.39-5.519M13.533 13.692a18.174 18.174 0 01-3.923 7.085c-.943 1.051-2.031 2.003-3.334 2.548-.705.291-1.479.46-2.23.338-.75-.123-1.479-.56-1.816-1.244-.529-1.059-.023-2.356.69-3.308 1.203-1.604 2.942-2.717 4.751-3.576 1.809-.86 3.717-1.497 5.525-2.357",
                                                    transform: "translate(0 152.736)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M14.729 13.93c2.69.43 5.272 1.474 7.502 3.032 1.157.806 2.238 1.773 2.928 3.001.375.66.636 1.412.605 2.172-.03.76-.375 1.535-1.011 1.957-.99.66-2.338.315-3.365-.276-1.74-.998-3.057-2.594-4.13-4.29-1.073-1.697-1.939-3.508-3.012-5.204",
                                                    transform: "translate(0 152.736)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#000601",
                                            d: "M13.986 18.075c4.46 0 4.467-6.946 0-6.946-4.468 0-4.468 6.946 0 6.946z",
                                            transform: "translate(0 152.736)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#FCFCFC",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.58 9.54a12.389 12.389 0 012.099-5.073c.552-.783 1.21-1.504 2.046-1.973.452-.253.958-.422 1.479-.399.521.023 1.035.261 1.318.699.437.675.2 1.589-.207 2.28-.69 1.174-1.778 2.056-2.927 2.778-1.15.721-2.391 1.297-3.54 2.01",
                                                    transform: "translate(285.075 82.124)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.817 9.394a12.34 12.34 0 015.157-1.865c.95-.115 1.931-.115 2.836.192.49.161.957.422 1.287.821.33.4.506.944.375 1.443-.199.783-1.042 1.213-1.823 1.382-1.326.284-2.713.069-4.024-.3-1.31-.368-2.567-.897-3.87-1.266M10.177 9.156a12.286 12.286 0 01-5.242 1.628c-.95.069-1.931.03-2.82-.315-.483-.184-.943-.468-1.249-.883-.314-.414-.46-.967-.307-1.458.238-.768 1.096-1.167 1.886-1.297 1.34-.223 2.712.054 4 .476 1.287.43 2.521 1.013 3.809 1.443",
                                                    transform: "translate(285.075 82.124)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.146 9.863A12.32 12.32 0 016.445 5.81c-.468-.829-.85-1.742-.92-2.694-.038-.514.023-1.051.26-1.512.238-.46.675-.829 1.189-.906.797-.115 1.517.492 1.977 1.16.774 1.12 1.11 2.478 1.272 3.83.16 1.35.16 2.716.322 4.067M10.307 10.131a12.26 12.26 0 011.372 5.32c.023.958-.061 1.933-.452 2.808-.207.476-.514.914-.935 1.213-.43.292-.989.414-1.472.238-.758-.276-1.11-1.151-1.203-1.95-.153-1.35.177-2.717.667-3.983.49-1.266 1.127-2.471 1.617-3.746M9.633 9.832a12.36 12.36 0 01-2.66 4.805c-.635.713-1.379 1.358-2.26 1.726-.475.2-1.004.315-1.51.23-.513-.084-1.004-.383-1.234-.844-.36-.721-.015-1.596.468-2.24.812-1.09 2-1.843 3.226-2.426C6.89 10.5 8.184 10.07 9.411 9.486",
                                                    transform: "translate(285.075 82.124)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.437 9.993c1.824.292 3.572.998 5.089 2.057.782.545 1.517 1.205 1.985 2.034.253.453.429.96.413 1.474-.015.514-.252 1.043-.682 1.327-.666.446-1.586.215-2.283-.192-1.18-.675-2.07-1.757-2.797-2.908-.728-1.152-1.318-2.38-2.039-3.531",
                                                    transform: "translate(285.075 82.124)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#000601",
                                            d: "M9.94 12.802c3.026 0 3.026-4.705 0-4.705-3.028 0-3.028 4.705 0 4.705z",
                                            transform: "translate(285.075 82.124)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#FF5E1E",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.71 9.34a12.125 12.125 0 012.069-4.996c.544-.767 1.195-1.481 2.015-1.942.444-.245.943-.414 1.456-.391.506.023 1.02.26 1.303.683.429.668.191 1.566-.207 2.249-.675 1.159-1.747 2.026-2.882 2.732-1.134.706-2.352 1.274-3.486 1.98",
                                                    transform: "translate(87.362)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.94 9.195a12.079 12.079 0 015.08-1.835c.935-.115 1.9-.115 2.79.192.482.162.942.422 1.272.814.322.391.498.929.367 1.428-.199.767-1.026 1.197-1.8 1.358-1.31.276-2.675.07-3.962-.292-1.288-.36-2.53-.882-3.809-1.25M10.292 8.965a12.146 12.146 0 01-5.158 1.604c-.935.069-1.9.03-2.781-.315-.475-.184-.928-.46-1.234-.867C.812 8.98.667 8.435.812 7.944c.238-.76 1.08-1.151 1.862-1.282 1.319-.215 2.675.046 3.947.468 1.272.422 2.483.998 3.755 1.42",
                                                    transform: "translate(87.362)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.269 9.663A12.2 12.2 0 016.62 5.672c-.467-.821-.835-1.712-.904-2.656-.038-.506.023-1.036.26-1.489.238-.452.667-.813 1.173-.89.782-.115 1.494.484 1.946 1.136.759 1.105 1.096 2.44 1.257 3.776.161 1.328.161 2.671.314 4.007M10.422 9.924a12.238 12.238 0 011.357 5.242c.023.944-.062 1.904-.445 2.77-.207.469-.506.907-.927 1.19-.422.292-.973.407-1.449.238-.743-.268-1.095-1.128-1.187-1.918-.154-1.328.176-2.671.659-3.922.482-1.251 1.11-2.441 1.594-3.684M9.755 9.632a12.26 12.26 0 01-2.62 4.736c-.629.698-1.357 1.335-2.223 1.696-.467.192-.988.307-1.486.23-.506-.076-.99-.376-1.211-.829-.353-.706-.016-1.573.46-2.21.804-1.075 1.969-1.819 3.172-2.395 1.21-.575 2.483-.997 3.694-1.573",
                                                    transform: "translate(87.362)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.552 9.786c1.794.284 3.518.982 5.012 2.026.774.537 1.495 1.182 1.954 2.003.253.445.422.944.406 1.45-.015.507-.252 1.03-.674 1.306-.659.437-1.563.207-2.245-.185-1.157-.667-2.039-1.734-2.759-2.862-.72-1.129-1.295-2.349-2.008-3.477",
                                                    transform: "translate(87.362)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#000601",
                                            d: "M10.054 12.549c2.981 0 2.981-4.636 0-4.636-2.98 0-2.98 4.636 0 4.636z",
                                            transform: "translate(87.362)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#FF5E1E",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.081 8.765a12.125 12.125 0 012.07-4.996c.543-.768 1.195-1.482 2.015-1.942.444-.246.942-.415 1.456-.392.505.023 1.019.261 1.302.683.43.668.192 1.566-.207 2.25-.674 1.158-1.747 2.025-2.88 2.732-1.135.706-2.354 1.274-3.488 1.98",
                                                    transform: "translate(245.226 9.978)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.31 8.62a12.079 12.079 0 015.082-1.835c.935-.115 1.9-.115 2.79.192.482.16.942.422 1.271.813.322.392.498.929.368 1.428-.2.767-1.027 1.197-1.8 1.358-1.311.277-2.675.07-3.963-.291-1.287-.361-2.529-.883-3.808-1.251M9.663 8.389a12.146 12.146 0 01-5.157 1.604c-.935.07-1.9.03-2.782-.315-.475-.184-.927-.46-1.234-.867C.184 8.404.038 7.86.184 7.368c.237-.76 1.08-1.151 1.862-1.282 1.318-.215 2.675.046 3.947.469 1.272.422 2.483.997 3.755 1.42",
                                                    transform: "translate(245.226 9.978)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.633 9.087a12.2 12.2 0 01-3.648-3.99c-.467-.822-.835-1.712-.904-2.656-.039-.507.023-1.036.26-1.49C5.58.5 6.008.139 6.514.062c.781-.115 1.494.484 1.946 1.136.759 1.106 1.096 2.441 1.257 3.777.161 1.327.161 2.67.314 4.006M9.794 9.348a12.238 12.238 0 011.356 5.242c.023.945-.061 1.904-.444 2.771-.207.468-.506.906-.928 1.19-.421.284-.973.407-1.448.238-.743-.269-1.096-1.128-1.188-1.919-.153-1.328.176-2.671.66-3.922.482-1.251 1.11-2.44 1.593-3.684M9.127 9.057a12.26 12.26 0 01-2.62 4.735c-.63.699-1.357 1.336-2.223 1.696-.468.192-.989.307-1.487.23-.506-.076-.988-.375-1.21-.828-.353-.706-.016-1.574.46-2.21.804-1.075 1.969-1.82 3.172-2.395 1.203-.576 2.483-.998 3.693-1.574",
                                                    transform: "translate(245.226 9.978)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.924 9.21c1.793.284 3.517.983 5.012 2.026.774.538 1.494 1.182 1.954 2.004.253.445.421.944.406 1.45-.015.507-.253 1.029-.674 1.305-.66.438-1.564.207-2.246-.184-1.157-.668-2.038-1.735-2.758-2.863-.72-1.128-1.296-2.349-2.008-3.477",
                                                    transform: "translate(245.226 9.978)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#000601",
                                            d: "M9.426 11.98c2.98 0 2.98-4.635 0-4.635-2.981 0-2.981 4.636 0 4.636z",
                                            transform: "translate(245.226 9.978)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "Path",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            fill: "#FF5E1E",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.518 8.888a12.125 12.125 0 012.069-4.997c.544-.767 1.195-1.481 2.015-1.942.445-.245.943-.414 1.456-.39.506.022 1.02.26 1.303.682.43.668.192 1.566-.207 2.249-.674 1.159-1.747 2.026-2.881 2.732-1.134.706-2.353 1.274-3.487 1.98",
                                                    transform: "translate(277.412 184.204)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.755 8.742a12.079 12.079 0 015.081-1.834c.935-.115 1.9-.115 2.79.192.482.16.942.422 1.272.813.322.392.498.929.368 1.428-.2.767-1.027 1.197-1.801 1.358-1.31.276-2.675.07-3.962-.291-1.288-.361-2.53-.883-3.809-1.252M10.108 8.512a12.146 12.146 0 01-5.157 1.604c-.935.069-1.901.03-2.782-.315-.475-.184-.928-.46-1.234-.867C.628 8.527.483 7.982.628 7.49c.238-.76 1.073-1.151 1.863-1.282 1.318-.215 2.674.046 3.946.468 1.272.423 2.483.998 3.755 1.42",
                                                    transform: "translate(277.412 184.204)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.077 9.203A12.2 12.2 0 016.43 5.21c-.468-.82-.836-1.711-.905-2.655-.038-.507.023-1.036.26-1.49.238-.452.668-.813 1.173-.89C7.74.062 8.453.66 8.905 1.313 9.663 2.418 10 3.753 10.162 5.09c.16 1.327.16 2.678.314 4.006M10.238 9.463a12.238 12.238 0 011.357 5.243c.023.944-.062 1.903-.445 2.77-.207.469-.506.906-.927 1.19-.422.292-.973.407-1.449.238-.743-.269-1.095-1.128-1.187-1.919-.154-1.328.176-2.67.659-3.922.483-1.25 1.11-2.44 1.594-3.684M9.571 9.172a12.26 12.26 0 01-2.62 4.735c-.629.699-1.357 1.336-2.223 1.697-.467.191-.988.307-1.486.23-.506-.077-.989-.376-1.211-.83-.353-.705-.016-1.572.46-2.21.804-1.074 1.97-1.819 3.172-2.394 1.211-.576 2.483-.998 3.694-1.574",
                                                    transform: "translate(277.412 184.204)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.368 9.333c1.794.284 3.518.982 5.012 2.026.774.537 1.495 1.182 1.954 2.003.253.446.422.944.407 1.451-.016.507-.253 1.029-.675 1.305-.659.437-1.563.207-2.245-.184-1.157-.668-2.039-1.735-2.759-2.863-.72-1.128-1.295-2.349-2.008-3.477",
                                                    transform: "translate(277.412 184.204)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#000601",
                                            d: "M9.87 12.096c2.981 0 2.989-4.636 0-4.636-2.988 0-2.98 4.636 0 4.636z",
                                            transform: "translate(277.412 184.204)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Group",
                            fill: "#FFF",
                            transform: "translate(8 12)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    d: "M285.413 100.942c0 .744-.605 1.35-1.348 1.35a1.352 1.352 0 010-2.701c.743 0 1.348.606 1.348 1.35z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    id: "Oval",
                                    cx: "304.192",
                                    cy: "119.836",
                                    rx: "3.065",
                                    ry: "3.07"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Path",
                                    d: "M161.5 2.701c0 1.22-.988 2.218-2.213 2.218a2.212 2.212 0 01-2.215-2.218c0-1.228.989-2.218 2.215-2.218 1.225 0 2.214.99 2.214 2.218zM9.048 186.596a4.256 4.256 0 01-4.252 4.26 4.26 4.26 0 01-4.252-4.26 4.26 4.26 0 014.252-4.26 4.26 4.26 0 014.252 4.26zM94.752 73.314c0 .744-.605 1.35-1.348 1.35a1.352 1.352 0 010-2.701c.743 0 1.348.606 1.348 1.35zM57.279 14.98c0 .745-.605 1.351-1.349 1.351a1.352 1.352 0 010-2.701c.744 0 1.349.606 1.349 1.35zM302.844 156.973c0 .744-.606 1.35-1.349 1.35a1.352 1.352 0 010-2.701c.743 0 1.349.606 1.349 1.35zM7.485 130.028c0 .744-.605 1.35-1.348 1.35a1.352 1.352 0 010-2.701c.743 0 1.348.606 1.348 1.35zM253.05 30.114c0 .745-.605 1.351-1.348 1.351a1.352 1.352 0 010-2.701c.743 0 1.348.606 1.348 1.35zM265.163 196.058c0 .745-.605 1.351-1.348 1.351a1.352 1.352 0 010-2.701c.743 0 1.348.606 1.348 1.35z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Group",
                            transform: "translate(46 10)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "book5",
                                    transform: "translate(63.523 61.343)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FCFCFC",
                                            d: "M3.62 4.056s5.694 9.861 0 23.794l137.54-1.634 1.385-.49V6.816l-3.413-2.767H3.62v.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#878784",
                                            d: "M136.928 4.463s5.365 8.312 0 22.244c0 0 6.382-1.794 6.344-10.351-.038-8.558-2.763-11.656-6.344-11.901v.008z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#061760",
                                            d: "M.36 28.724a2.408 2.408 0 012.388-2.439l133.812-1.211c2.71-.023 4.998-3.374 4.998-7.308v-4.953c0-3.957-2.304-7.307-5.028-7.307H2.778A2.413 2.413 0 01.368 3.09 2.413 2.413 0 012.777.675h133.76c5.433 0 9.85 5.444 9.85 12.138v4.953c0 6.756-4.294 12.093-9.774 12.139L2.8 31.116a2.408 2.408 0 01-2.434-2.392H.36z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Rectangle",
                                            fill: "#DDD",
                                            transform: "translate(20.664 9.201)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6.812 0.445H99.97V1.445H6.812z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0.704 6.073H105.70899999999999V7.073H0.704z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6.812 11.701H99.97V12.701H6.812z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "book3",
                                    transform: "translate(47.451 121.152)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FCFCFC",
                                            d: "M3.934 3.85s5.694 9.86 0 23.793l137.54-1.634 1.385-.49V6.609l-3.414-2.767H3.934v.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#878784",
                                            d: "M137.249 4.256s5.365 8.312 0 22.244c0 0 6.383-1.794 6.345-10.352-.039-8.557-2.763-11.655-6.345-11.9v.008z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FF5E1E",
                                            d: "M.681 28.517a2.408 2.408 0 012.388-2.439l133.813-1.211c2.709-.023 4.997-3.374 4.997-7.308v-4.953c0-3.957-2.303-7.308-5.028-7.308H3.1A2.413 2.413 0 01.689 2.883 2.413 2.413 0 013.099.468h133.76c5.434 0 9.85 5.444 9.85 12.138v4.953c0 6.756-4.294 12.093-9.774 12.146L3.123 30.917a2.408 2.408 0 01-2.434-2.393l-.008-.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Rectangle",
                                            fill: "#DDD",
                                            transform: "translate(21.43 9.201)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6.368 0.238H99.526V1.238H6.368z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0.26 5.866H105.265V6.866H0.26z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6.368 11.494H99.526V12.494H6.368z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "book4",
                                    transform: "translate(13.01 91.247)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FCFCFC",
                                            d: "M4.6 3.535s7.003 10.006 0 24.146l169.156-1.656 1.699-.499V6.341l-4.202-2.814H4.6v.008z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#878784",
                                            d: "M169.286 3.949s5.978 8.435 0 22.574c0 0 7.11-1.817 7.064-10.497-.046-8.68-3.076-11.824-7.064-12.07V3.95z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FFD357",
                                            d: "M.597 28.563c-.015-1.357 1.301-2.462 2.939-2.477l164.572-1.235c3.329-.023 6.145-3.42 6.145-7.414v-5.03c0-4.018-2.831-7.415-6.176-7.415H3.567c-1.638 0-2.97-1.097-2.97-2.454 0-1.357 1.332-2.454 2.97-2.454h164.51c6.681 0 12.115 5.529 12.115 12.323v5.03c0 6.855-5.28 12.268-12.023 12.322L3.597 30.994C1.96 31.009.62 29.92.605 28.563H.597z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Rectangle",
                                            fill: "#DDD",
                                            transform: "translate(26.022 9.201)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M7.921 0.008H122.49300000000001V1.008H7.921z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0.406 5.713H129.55V6.713H0.406z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M7.921 11.425H122.49300000000001V12.425H7.921z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "book2",
                                    transform: "translate(0 150.29)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FCFCFC",
                                            d: "M4.715 3.941s7.002 9.861 0 23.794L173.87 26.1l1.699-.49V6.7l-4.202-2.767H4.715v.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#878784",
                                            d: "M169.118 4.654s5.977 8.312 0 22.245c0 0 7.11-1.794 7.064-10.352-.046-8.557-3.077-11.655-7.064-11.9v.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FFD357",
                                            d: "M.72 28.609c-.016-1.334 1.3-2.431 2.938-2.439L168.23 24.96c3.33-.023 6.146-3.374 6.146-7.308v-4.953c0-3.957-2.832-7.308-6.177-7.308H3.681c-1.638 0-2.97-1.08-2.97-2.415C.712 1.641 2.044.56 3.682.56h164.51c6.682 0 12.116 5.444 12.116 12.138v4.953c0 6.756-5.28 12.093-12.023 12.139L3.712 31C2.074 31.016.735 29.943.719 28.61z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Rectangle",
                                            fill: "#DDD",
                                            transform: "translate(26.022 9.201)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8.036 0.33H122.608V1.33H8.036z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0.528 5.958H129.672V6.958H0.528z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8.036 11.586H122.608V12.586H8.036z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "book1",
                                    transform: "translate(31.38 179.428)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#FCFCFC",
                                            d: "M4.653 3.489s7.003 12.176 0 29.383l169.156-2.009 1.7-.606V6.91l-4.202-3.42H4.653z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#878784",
                                            d: "M169.049 4.194s5.977 10.712 0 28.678c0 0 7.11-2.308 7.064-13.342-.046-11.026-3.077-15.021-7.064-15.336z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "Path",
                                            fill: "#061760",
                                            d: "M.65 34.498a2.962 2.962 0 012.94-2.99L168.16 30.02c3.33-.031 6.146-4.133 6.146-8.956v-6.081c0-4.854-2.832-8.956-6.176-8.956H3.62a2.969 2.969 0 110-5.935h164.51c6.681 0 12.115 6.679 12.115 14.891v6.08c0 8.29-5.28 14.823-12.024 14.892L3.651 37.442a2.967 2.967 0 01-2.993-2.937l-.008-.007z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "Rectangle",
                                            fill: "#DDD",
                                            transform: "translate(26.022 11.502)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M7.975 0.736H122.547V1.736H7.975z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0.467 6.364H129.61100000000002V7.364H0.467z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M7.975 11.993H122.547V12.993H7.975z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "openBook",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#FEFFFF",
                                            d: "M164.855 57.578c0-6.372-4.944-11.632-11.289-12.031-13.194-.836-35.252-1.626-51.24.874 12.276-2.27 42.17-7.307 60.225-6.203-.513-4.54-4.301-7.998-8.855-8.082-13.577-.245-41.336.376-58.143 8.435 0 0 24.131-16.034 62.942-14.347-.314-7.675-6.896-13.557-14.542-12.997-14.755 1.074-38.32 5.567-56.536 22.122 0 0 13.08-24.622 41.015-33.21a5.2 5.2 0 00-5.365-1.05c-8.564 3.228-32.466 13.802-38.099 33.079C79.335 14.89 55.434 4.317 46.87 1.088a5.184 5.184 0 00-5.365 1.051c27.935 8.588 41.014 33.21 41.014 33.21C64.312 18.794 40.74 14.3 25.983 13.227c-7.645-.56-14.227 5.33-14.541 12.997 38.803-1.68 62.942 14.347 62.942 14.347-16.807-8.06-44.574-8.68-58.143-8.435-4.562.084-8.343 3.542-8.855 8.082 18.062-1.104 47.948 3.933 60.224 6.203-15.988-2.5-38.045-1.71-51.24-.874-6.344.399-11.288 5.667-11.288 12.03l79.772 1.741h.23l79.77-1.74z",
                                            transform: "translate(36.736)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#056354",
                                            d: "M86.323 64.372c-2.342 0-4.462-1.166-5.916-2.423a1.533 1.533 0 00-1.003-.36H2.013A1.589 1.589 0 01.429 60v-2.5c0-.874.711-1.587 1.584-1.587h78.41c.45 0 .88.192 1.178.529.184.2 4.691 5.015 8.87.054v-.016c.314-.36.758-.567 1.225-.567h76.098c.872 0 1.584.713 1.584 1.587v2.5c0 .874-.712 1.587-1.584 1.587h-74.98c-.43 0-.827.176-1.141.468-1.791 1.687-3.628 2.316-5.35 2.316z",
                                            transform: "translate(36.736)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#DDD",
                                            d: "M89.867 38.822c1.063-.705 2.173-1.357 3.275-2.001 2.932-1.71 5.94-3.297 8.993-4.792a143.743 143.743 0 0113.478-5.751c5.403-1.986 10.936-3.643 16.57-4.854 6.122-1.319 12.375-2.116 18.643-2.178.788-.007 1.584 0 2.373.008.336 0 .336-.521 0-.53-6.314-.114-12.636.522-18.835 1.718-5.786 1.112-11.473 2.707-17.022 4.655a143.588 143.588 0 00-13.96 5.75 138.988 138.988 0 00-9.658 5.03c-1.37.783-2.763 1.565-4.072 2.455-.015.015-.038.023-.053.038-.283.184-.016.644.268.452zM95.17 44.32c1.179-.337 2.365-.644 3.544-.943 3.145-.797 6.306-1.51 9.483-2.17 4.5-.935 9.03-1.748 13.577-2.415 5.35-.79 10.737-1.388 16.133-1.726 5.595-.345 11.22-.414 16.822-.03.666.046 1.324.1 1.99.153.337.03.337-.498 0-.529-5.58-.49-11.197-.514-16.784-.238-5.457.269-10.898.82-16.317 1.572a230.196 230.196 0 00-14.067 2.4 236.605 236.605 0 00-10.087 2.255c-1.454.36-2.939.69-4.37 1.142a.236.236 0 00-.061.015c-.322.092-.184.598.137.506v.008zM108.778 51.65a87.07 87.07 0 012.036-.206c1.776-.17 3.551-.315 5.334-.43 2.495-.16 4.99-.284 7.486-.337 2.831-.07 5.663-.062 8.487.053 2.77.115 5.549.33 8.296.752.322.046.643.1.957.153.138.023.283-.038.322-.184.038-.13-.046-.299-.184-.322-2.748-.475-5.534-.736-8.312-.882a126.63 126.63 0 00-8.533-.13c-2.564.046-5.12.146-7.677.307-1.89.115-3.78.26-5.67.437-.843.076-1.677.153-2.511.253h-.03c-.139.023-.261.115-.261.268 0 .13.122.276.26.26v.009zM40.724 20.573c.199.038.39.077.59.123.55.122 1.109.245 1.66.375.85.207 1.7.422 2.549.652a99.564 99.564 0 017.133 2.231 104.7 104.7 0 014.24 1.61c1.5.614 2.992 1.266 4.454 1.964a73.438 73.438 0 014.561 2.369c1.516.859 3 1.779 4.447 2.76 1.439.99 2.832 2.04 4.163 3.175.33.276.651.567.972.851.253.23.62-.146.375-.376a47.558 47.558 0 00-4.117-3.32 59.631 59.631 0 00-4.408-2.883 68.672 68.672 0 00-4.554-2.47 80.6 80.6 0 00-4.531-2.077 101.77 101.77 0 00-4.378-1.733 105.873 105.873 0 00-3.98-1.365 93.566 93.566 0 00-3.451-1.035 86.101 86.101 0 00-4.661-1.173c-.291-.062-.582-.13-.873-.184h-.038c-.33-.07-.475.437-.138.498l-.015.008zM21.828 36.775a99.708 99.708 0 013.39.046c2.985.077 5.97.222 8.955.422 4.24.283 8.464.69 12.681 1.227 4.89.62 9.766 1.426 14.588 2.469 4.929 1.065 9.804 2.392 14.549 4.11.582.214 1.163.429 1.745.651.314.123.451-.383.138-.506-4.738-1.84-9.644-3.25-14.595-4.386-4.845-1.112-9.75-1.97-14.68-2.637a211.234 211.234 0 00-13.01-1.358 207.707 207.707 0 00-9.521-.498c-1.393-.038-2.802-.115-4.187-.07h-.053c-.337 0-.337.53 0 .53zM17.435 51.743c.918-.077 1.836-.13 2.762-.184a230.95 230.95 0 017.279-.315c3.49-.1 6.98-.13 10.47-.076 4.048.053 8.097.222 12.138.52 4.202.315 8.388.783 12.536 1.496.49.085.98.169 1.462.26.33.062.475-.444.138-.505-4.125-.775-8.289-1.288-12.468-1.649-4.102-.353-8.22-.544-12.33-.629-3.589-.076-7.178-.06-10.768.023-2.594.062-5.196.161-7.79.307-1.126.062-2.266.115-3.391.223h-.046c-.337.03-.337.56 0 .529h.008z",
                                            transform: "translate(36.736)"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageReadPages.tsx












var HomepageReadPages_useStyles = (0,create_styles/* createStyles */.k)(function(theme, param) {
    var additionalText = param.additionalText;
    var _obj, _obj1, _obj2;
    return {
        grid: (_obj = {
            display: "grid",
            gridTemplateColumns: "1fr",
            overflow: "hidden",
            "> svg": (0,_define_property/* default */.Z)({
                maxWidth: "100%",
                height: "auto",
                transform: "translateX(-12%)"
            }, theme.fn.largerThan("sm"), {
                transform: "none"
            })
        }, (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("sm"), {
            rowGap: additionalText ? theme.spacing.xs : 0,
            "> *": {
                gridColumn: "1 / 2",
                gridRow: "1 / 2"
            },
            "> *:nth-child(n+2)": {
                gridRow: additionalText ? "2 / 3" : "1 / 2"
            }
        }), (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("sm"), {
            gridTemplateColumns: "1fr 1fr"
        }), _obj),
        text: (_obj1 = {
            alignSelf: "center",
            zIndex: 1
        }, (0,_define_property/* default */.Z)(_obj1, theme.fn.smallerThan("sm"), {
            placeSelf: "start",
            zIndex: 1
        }), (0,_define_property/* default */.Z)(_obj1, theme.fn.largerThan("sm"), {
            gridRow: additionalText ? "span 1" : "span 2"
        }), _obj1),
        svg: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, theme.fn.smallerThan("sm"), {
            placeSelf: "end",
            maxWidth: "75%",
            marginTop: additionalText ? 25 : 60,
            "> svg": {
                maxWidth: "100%",
                height: "auto"
            }
        }), (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("sm"), {
            gridRow: "1 / 3",
            gridColumn: "2 / 3"
        }), _obj2),
        readPages: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 900,
            fontSize: 60
        }, theme.fn.largerThan("sm"), {
            fontSize: 85
        }),
        readPagesCurrent: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 900,
            fontSize: 30
        }, theme.fn.largerThan("sm"), {
            fontSize: 50
        }),
        readPagesSubtext: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 700,
            fontSize: 24
        }, theme.fn.largerThan("sm"), {
            fontSize: 35
        }),
        readPagesCurrentSubtext: (0,_define_property/* default */.Z)({
            lineHeight: 1,
            fontWeight: 700,
            fontSize: 20
        }, theme.fn.largerThan("sm"), {
            fontSize: 30
        }),
        readPagesSubSubtext: {
            fontSize: 25,
            lineHeight: 1
        }
    };
});
var HomepageReadPages_formatter = new Intl.NumberFormat("de-DE");
var HomepageReadPages = function(_param) {
    var readPages = _param.readPages, readPagesCurrentYear = _param.readPagesCurrentYear, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "readPages",
        "readPagesCurrentYear"
    ]);
    var additionalText = readPagesCurrentYear && readPagesCurrentYear >= 250000;
    var classes = HomepageReadPages_useStyles({
        additionalText: additionalText
    }).classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    (0,react.useEffect)(function() {
        if (false) {}
        gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
        var t = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                trigger: "#readPages-stats",
                start: "top center+=10%",
                end: "bottom center+=10%"
            }
        });
        t.from("#book-svg", {
            yPercent: 20,
            opacity: 0,
            duration: 0.3
        }).from("#readPages-text, #readPages-current-text", {
            xPercent: -100,
            opacity: 0,
            duration: 0.3
        }, "<").fromTo("#readPages", {
            textContent: "100000"
        }, {
            textContent: readPages.toString(),
            duration: 2,
            ease: "power3.out",
            // ease: 'none',
            snap: {
                textContent: 1
            },
            onUpdate: function onUpdate() {
                var targets = this.targets();
                if (targets && targets[0]) {
                    targets[0].innerHTML = HomepageReadPages_formatter.format(this.targets()[0].textContent);
                }
            }
        }, "<").from([
            "#book1",
            "#book2",
            "#book3",
            "#book4",
            "#book5",
            "#openBook"
        ], {
            opacity: 0,
            duration: 2.5,
            stagger: 0.25
        }, "<");
        if (additionalText) {
            t.fromTo("#readPages-current", {
                textContent: "10000"
            }, {
                textContent: readPagesCurrentYear.toString(),
                duration: 2,
                ease: "power3.out",
                // ease: 'none',
                snap: {
                    textContent: 1
                },
                onUpdate: function onUpdate() {
                    var targets = this.targets();
                    if (targets && targets[0]) {
                        targets[0].innerHTML = HomepageReadPages_formatter.format(this.targets()[0].textContent);
                    }
                }
            }, "<+=0.5");
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: "readPages-stats",
            className: classes.grid
        }, boxProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    id: "readPages-text",
                    spacing: 0,
                    className: classes.text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            id: "readPages",
                            className: classes.readPages,
                            children: readPages
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            className: classes.readPagesSubtext,
                            children: t("stats.readPages.description")
                        })
                    ]
                }),
                additionalText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    id: "readPages-current-text",
                    spacing: 0,
                    className: classes.text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            id: "readPages-current",
                            className: classes.readPagesCurrent,
                            children: readPagesCurrentYear
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            className: classes.readPagesCurrentSubtext,
                            children: t("stats.readPages.currentYear", {
                                count: readPagesCurrentYear
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "book-svg",
                    className: classes.svg,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BooksSvg, {})
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageSchools.tsx








var HomepageSchools_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            flexDirection: "column-reverse",
            marginTop: 50
        }),
        schools: {
            fontSize: 50,
            lineHeight: 1,
            fontWeight: 900
        },
        schoolsSubtext: {
            fontSize: 25,
            lineHeight: 1
        }
    };
});
var HomepageSchools = function(param) {
    var schoolsCount = param.schoolsCount;
    var classes = HomepageSchools_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    (0,react.useEffect)(function() {
        if (false) {}
        gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
        gsap/* default.from */.ZP.from("#schools > *", {
            yPercent: 20,
            opacity: 0,
            duration: 1,
            stagger: 0.25,
            scrollTrigger: {
                id: "schools",
                trigger: "#schools",
                start: "top center+=10%",
                end: "bottom center+=10%"
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        id: "schools",
        position: "center",
        align: "center",
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: "/static/statistics/school.svg",
                sx: {
                    maxWidth: 376
                },
                alt: "Illustration einer Schule"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: 0,
                align: "end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.schools,
                        children: t("stats.schools.unit", {
                            count: schoolsCount
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        align: "right",
                        className: classes.schoolsSubtext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18n/* Trans */.cC, {
                            ns: "page_homepage",
                            i18nKey: "stats.schools.description"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageStudents.tsx








var HomepageStudents_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        students: (0,_define_property/* default */.Z)({
            fontSize: 30,
            lineHeight: 1,
            fontWeight: 900,
            marginTop: 30
        }, theme.fn.largerThan("xs"), {
            fontSize: 55,
            marginTop: 0
        }),
        studentsSubtext: {
            fontSize: 25,
            lineHeight: 1
        }
    };
});
var HomepageStudents = function(param) {
    var studentsCount = param.studentsCount;
    var classes = HomepageStudents_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,i18n/* useTranslation */.$G)("page_homepage"), 1), t = ref[0];
    (0,react.useEffect)(function() {
        if (false) {}
        gsap/* default.registerPlugin */.ZP.registerPlugin(ScrollTrigger.ScrollTrigger);
        gsap/* default.from */.ZP.from("#students > *", {
            yPercent: 20,
            opacity: 0,
            duration: 1,
            stagger: 0.25,
            scrollTrigger: {
                id: "students",
                trigger: "#students",
                start: "top center+=10%",
                end: "bottom center+=10%"
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        id: "students",
        position: "center",
        mt: "xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.students,
                        children: t("stats.students.unit", {
                            count: studentsCount
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        className: classes.studentsSubtext,
                        children: t("stats.students.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: "/static/statistics/students.png",
                sx: {
                    maxWidth: 300
                },
                alt: "Illustration von Sch\xfclern"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Default/Homepage/HomepageStats.tsx


// eslint-disable-next-line import/no-internal-modules





var HomepageStats = function(param) {
    var stats = param.stats;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        size: "md",
        sx: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHeight, {
                mb: 50,
                readPages: stats.readPages.total,
                readPagesCurrentYear: stats.readPages.currentYear
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageReadPages, {
                mb: 50,
                readPages: stats.readPages.total,
                readPagesCurrentYear: stats.readPages.currentYear
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageSchools, {
                schoolsCount: stats.schools.total
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageStudents, {
                studentsCount: stats.students.active
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx







var Welcome = function(param) {
    var stats = param.stats;
    /*/
  const { data: stats } = useQuery<IStats>(['stats'], async () => {
    const res = await fetch('/stats', {credentials: 'same-origin'});
    return await res.json();
  });
  /**/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "NEXT LEVEL"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageIntroText, {}),
                    stats && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageStats, {
                        stats: stats
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageNextStudent, {}),
                    stats && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageLatestBooksList, {
                        latestBooks: stats.latestBooks
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/**/ /*/
export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${process.env.NEXT_PUBLIC_ENTRYPOINT}/stats`);
  const stats = await res.json();

  return {
    props: {
      stats,
    },
  };
};
/**/ /* harmony default export */ var pages = (Welcome);


/***/ }),

/***/ 42729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ formatUnit; },
/* harmony export */   "u": function() { return /* binding */ formatNumber; }
/* harmony export */ });
var formatUnit = function(value, lng) {
    var numberFormatter = new Intl.NumberFormat(lng, {
        maximumFractionDigits: 2
    });
    // to start value is in mm
    if (value > 1000) {
        return "".concat(numberFormatter.format(value / 1000), " m");
    }
    if (value > 10) {
        return "".concat(numberFormatter.format(value / 10), " cm");
    }
    return "".concat(numberFormatter.format(value), " mm");
};
var formatNumber = function(value) {
    var lng = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "de";
    var numberFormatter = new Intl.NumberFormat(lng, {
        maximumFractionDigits: 2
    });
    return numberFormatter.format(value);
};


/***/ }),

/***/ 70545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getStackHeightInMM; }
/* harmony export */ });
var GRAMMAGE = 135;
var VOLUME_FACTOR = 1.3;
function getStackHeightInMM(pages) {
    return pages / 2 * GRAMMAGE * VOLUME_FACTOR / 1000;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8802,3662,4689,7841,1664,5590,1580,4725,1648,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);